import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
/* eslint-disable */


export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
};

export type AdditionalData = {
  __typename?: 'AdditionalData';
  maker?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AddressData = {
  __typename?: 'AddressData';
  city?: Maybe<Scalars['String']['output']>;
  cityAndZipCode?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  streetAndHouseNumber?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type Admin = {
  __typename?: 'Admin';
  active?: Maybe<Scalars['Boolean']['output']>;
  additionalExt?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  alternateStartDate?: Maybe<Scalars['String']['output']>;
  assignments?: Maybe<Array<Maybe<AdminAssignment>>>;
  avatar?: Maybe<Scalars['String']['output']>;
  custodiaID?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  id?: Maybe<Scalars['String']['output']>;
  kompareID?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  newRoles?: Maybe<Array<Maybe<Role>>>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneExt?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Maybe<AdminRole>>>;
  sdaDefaultReports?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  signature?: Maybe<Scalars['String']['output']>;
  teamleaderId?: Maybe<Scalars['String']['output']>;
};

export type AdminAssignTeamleaderInput = {
  adminId: Scalars['String']['input'];
  teamleaderId?: InputMaybe<Scalars['String']['input']>;
};

export type AdminAssignment = {
  __typename?: 'AdminAssignment';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type AdminCallData = {
  __typename?: 'AdminCallData';
  blink: Scalars['Boolean']['output'];
  hot?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminCallsData = {
  __typename?: 'AdminCallsData';
  data?: Maybe<AdminCallData>;
};

export type AdminInput = {
  id: Scalars['String']['input'];
};

export type AdminRole = {
  __typename?: 'AdminRole';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminRoleDefinition = {
  __typename?: 'AdminRoleDefinition';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AdminRoleDefinitionRoot = {
  __typename?: 'AdminRoleDefinitionRoot';
  adminRoleDefinition?: Maybe<Array<Maybe<AdminRoleDefinition>>>;
};

export type AdminRoot = {
  __typename?: 'AdminRoot';
  admin?: Maybe<Array<Maybe<Admin>>>;
  adminByDepartment?: Maybe<Array<Maybe<Admin>>>;
  adminById?: Maybe<Admin>;
  assignedAdminByReference?: Maybe<PublicAdmin>;
  me?: Maybe<Admin>;
  supportFromAdmin?: Maybe<Array<Maybe<Admin>>>;
};

export type AdminRootAdminByDepartmentArgs = {
  referenceType: Scalars['String']['input'];
};

export type AdminRootAdminByIdArgs = {
  params: AdminInput;
};

export type AdminRootAssignedAdminByReferenceArgs = {
  isEncrypted: Scalars['Boolean']['input'];
  referenceId: Scalars['String']['input'];
  referenceType: Scalars['String']['input'];
};

export type AdminStatus = {
  admin?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  pauseType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type AllTicketCategories = {
  __typename?: 'AllTicketCategories';
  allCategories?: Maybe<Array<Maybe<TicketCategory>>>;
  filteredCategories?: Maybe<Array<Maybe<TicketCategory>>>;
};

export type AoAdditionalCoverage = {
  __typename?: 'AoAdditionalCoverage';
  amount?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  groupCode?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
};

export type AoAdditionalPriceModifier = {
  __typename?: 'AoAdditionalPriceModifier';
  amount?: Maybe<Scalars['Float']['output']>;
  amountType?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  modifiedAmount?: Maybe<Scalars['Float']['output']>;
  originalAmount?: Maybe<Scalars['Float']['output']>;
  validFrom?: Maybe<Scalars['String']['output']>;
  validTo?: Maybe<Scalars['String']['output']>;
};

export type AoCoverage = {
  __typename?: 'AoCoverage';
  amount?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
};

export type AoPrice = {
  __typename?: 'AoPrice';
  additionalCoveragesMessage: Scalars['String']['output'];
  apiError?: Maybe<Scalars['String']['output']>;
  includedCalcValidationError?: Maybe<Scalars['String']['output']>;
  kasko?: Maybe<Scalars['Float']['output']>;
  kaskoAdditionalMessage: Scalars['String']['output'];
  kaskoNeedsApproval: Scalars['Boolean']['output'];
  maxCommissionDiscountMessage: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  priceWithCoverages: Scalars['Float']['output'];
  priceWithCoveragesAndMaxCommissionDiscount?: Maybe<Scalars['Float']['output']>;
  serviceBonusMalus?: Maybe<Scalars['Float']['output']>;
  validationError?: Maybe<Scalars['String']['output']>;
};

export type AoProduct = {
  __typename?: 'AoProduct';
  additionalCoverages?: Maybe<Array<Maybe<AoAdditionalCoverage>>>;
  additionalPriceModifiers?: Maybe<Array<Maybe<AoAdditionalPriceModifier>>>;
  code: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  packages?: Maybe<Array<Maybe<AoCoverage>>>;
  prices?: Maybe<AoPrice>;
  promotions?: Maybe<Array<Maybe<AoCoverage>>>;
  timeLimitedOffers?: Maybe<Array<Maybe<TimeLimitedOffer>>>;
  visual?: Maybe<AoProductVisual>;
};

export type AoProductVisual = {
  __typename?: 'AoProductVisual';
  description: Scalars['String']['output'];
  discount?: Maybe<Array<AoProductVisualDiscount>>;
  highlight: Scalars['Boolean']['output'];
  kaskoHighlight?: Maybe<Scalars['Boolean']['output']>;
  tooltip: Scalars['String']['output'];
  warning: Scalars['String']['output'];
};

export type AoProductVisualDiscount = {
  __typename?: 'AoProductVisualDiscount';
  code: Scalars['String']['output'];
  tooltip: Scalars['String']['output'];
};

export type AoRidersRoot = {
  __typename?: 'AoRidersRoot';
  kompareRiders: Array<KompareRider>;
  partnerRiders: Array<PartnerRider>;
  presignedUrlForFileUpload: PresignedUrlForFileUpload;
};

export type AoRoot = {
  __typename?: 'AoRoot';
  coverageGroups?: Maybe<Array<Maybe<CoverageGroup>>>;
  laqoPrice?: Maybe<LaqoPrices>;
  linkedRegistration?: Maybe<Array<Maybe<LinkedRegistration>>>;
  offer?: Maybe<Offer>;
  productList?: Maybe<ProductList>;
  products?: Maybe<Array<Maybe<AoProduct>>>;
  rawOffer?: Maybe<Offer>;
  registrationAssignments?: Maybe<Array<Maybe<RegistrationAssignments>>>;
  registrationHistory?: Maybe<Array<Maybe<RegistrationHistory>>>;
};

export type AoRootLaqoPriceArgs = {
  params: LaqoParams;
};

export type AoRootLinkedRegistrationArgs = {
  email: Scalars['String']['input'];
};

export type AoRootOfferArgs = {
  offerId: Scalars['String']['input'];
};

export type AoRootProductListArgs = {
  params: ProductListInput;
};

export type AoRootProductsArgs = {
  params: ProductsInput;
};

export type AoRootRawOfferArgs = {
  aoAdminRequest?: InputMaybe<Scalars['Boolean']['input']>;
  offerId: Scalars['String']['input'];
};

export type AoRootRegistrationAssignmentsArgs = {
  soId: Scalars['String']['input'];
};

export type AoRootRegistrationHistoryArgs = {
  registration: Scalars['String']['input'];
};

export type AppletDataInput = {
  inputName: Scalars['String']['input'];
  inputValue: Scalars['String']['input'];
};

export type Attachment = {
  _id: Scalars['String']['input'];
  metadata: AttachmentMetadata;
};

export type AttachmentIdName = {
  _id?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
};

export type AttachmentMetadata = {
  category: Scalars['String']['input'];
  createdAt: Scalars['String']['input'];
  createdBy: Scalars['String']['input'];
  createdByName?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['String']['input'];
  deletedAt?: InputMaybe<Scalars['String']['input']>;
  deletedBy?: InputMaybe<Scalars['String']['input']>;
  documentName: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  isDeleted: Scalars['Boolean']['input'];
  offerLink: Scalars['String']['input'];
  referenceId: Scalars['String']['input'];
  referenceName: Scalars['String']['input'];
  source: Scalars['String']['input'];
};

export type BasicConsentCheck = {
  __typename?: 'BasicConsentCheck';
  hasConsented?: Maybe<Scalars['Boolean']['output']>;
};

export type Brand = {
  __typename?: 'Brand';
  _id?: Maybe<Scalars['String']['output']>;
  administrationName?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  logoDetails: Scalars['String']['output'];
  logoResults: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ButtonAction = {
  __typename?: 'ButtonAction';
  nModified: Scalars['Int']['output'];
};

export type CalculationData = {
  __typename?: 'CalculationData';
  huo?: Maybe<HuoData>;
  isLeasing?: Maybe<Scalars['Boolean']['output']>;
  modifiedByAgent?: Maybe<ModifiedByAgentData>;
  offerType?: Maybe<Scalars['String']['output']>;
  policy?: Maybe<PolicyData>;
  registration?: Maybe<RegistrationData>;
  vehicle?: Maybe<VehicleData>;
  vehicleOwner?: Maybe<VehicleOwnerData>;
};

export type CalculationPrice = {
  __typename?: 'CalculationPrice';
  totalOneTimePayment: Scalars['Float']['output'];
  totalWithInstallments: Scalars['Float']['output'];
};

export type CallMeInput = {
  number: Scalars['String']['input'];
  product: Scalars['String']['input'];
};

export type CallOrderRoot = {
  __typename?: 'CallOrderRoot';
  dummyQuery?: Maybe<Scalars['Boolean']['output']>;
};

export type CategoryData = {
  __typename?: 'CategoryData';
  categoryName?: Maybe<Scalars['String']['output']>;
  categoryType?: Maybe<Scalars['String']['output']>;
  subCategory?: Maybe<Scalars['String']['output']>;
};

export type CategoryType = {
  __typename?: 'CategoryType';
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type ChangeTicketStatus = {
  __typename?: 'ChangeTicketStatus';
  _id: Scalars['String']['output'];
  assignedTo?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Flags>;
  status: Scalars['String']['output'];
};

export type CheckoutHealthOfferBasicConsentCheck = {
  __typename?: 'CheckoutHealthOfferBasicConsentCheck';
  customerId?: Maybe<Scalars['String']['output']>;
  hasConsented?: Maybe<Scalars['Boolean']['output']>;
};

export type CheckoutHealthOfferDataInput = {
  contractor: HealthOfferDataContractorInput;
  delivery: HealthOfferDataDeliveryInput;
  insuredPerson: HealthOfferDataInsuredPersonInput;
  offerId: Scalars['String']['input'];
};

export type CommunicationAppRoot = {
  __typename?: 'CommunicationAppRoot';
  ticketCategory?: Maybe<AllTicketCategories>;
  ticketMessages?: Maybe<Array<Maybe<MessageData>>>;
  tickets?: Maybe<Array<Maybe<Ticket>>>;
};

export type CommunicationAppRootTicketCategoryArgs = {
  adminId: Scalars['String']['input'];
};

export type CommunicationAppRootTicketMessagesArgs = {
  ticketId: Scalars['String']['input'];
};

export type CommunicationAppRootTicketsArgs = {
  referenceId: Scalars['String']['input'];
  referenceName: Scalars['String']['input'];
};

export type ConfirmCheckoutWsPaySignatureInput = {
  offerId: Scalars['String']['input'];
  wsPayAmount: Scalars['String']['input'];
  wsPayApprovalCode: Scalars['String']['input'];
  wsPayConfirmationSignature: Scalars['String']['input'];
  wsPayCreditCardNumber: Scalars['String']['input'];
  wsPayCustomerFirstName: Scalars['String']['input'];
  wsPayCustomerLastName: Scalars['String']['input'];
  wsPayDateTime: Scalars['String']['input'];
  wsPayOrderId: Scalars['String']['input'];
  wsPayPartner: Scalars['String']['input'];
  wsPayPaymentPlan: Scalars['String']['input'];
  wsPayPaymentType: Scalars['String']['input'];
  wsPaySTAN: Scalars['String']['input'];
  wsPayShoppingCartId: Scalars['String']['input'];
  wsPaySuccess: Scalars['String']['input'];
};

export type ConfirmCheckoutWsPaySignatureResponse = {
  __typename?: 'ConfirmCheckoutWSPaySignatureResponse';
  alreadyPaid?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ConsentInput = {
  consent?: InputMaybe<Array<InputMaybe<HealthConsent>>>;
  offerId: Scalars['String']['input'];
};

export type CoverageForWeb = {
  __typename?: 'CoverageForWeb';
  description: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type CoverageGroup = {
  __typename?: 'CoverageGroup';
  code?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  list?: Maybe<Array<Maybe<CoverageItem>>>;
};

export type CoverageItem = {
  __typename?: 'CoverageItem';
  brandCode?: Maybe<Scalars['String']['output']>;
  brandCoverageKey?: Maybe<Scalars['String']['output']>;
};

export type CrossSell = {
  __typename?: 'CrossSell';
  activityHistory?: Maybe<Array<Maybe<CustomerCrossSellActivityHistory>>>;
  emails?: Maybe<Array<Maybe<CustomerCrossSellEmails>>>;
  prospectCalls?: Maybe<Array<Maybe<CustomerCrossSellProspectCalls>>>;
};

export type CustomerButtonAction = {
  __typename?: 'CustomerButtonAction';
  msg: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CustomerCrossSellActivityHistory = {
  __typename?: 'CustomerCrossSellActivityHistory';
  Akcija?: Maybe<Scalars['String']['output']>;
  Datum_akcije?: Maybe<Scalars['String']['output']>;
  Detalji?: Maybe<Scalars['String']['output']>;
  FromCustomerAccount?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
};

export type CustomerCrossSellEmails = {
  __typename?: 'CustomerCrossSellEmails';
  emails?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type CustomerCrossSellProspectCalls = {
  __typename?: 'CustomerCrossSellProspectCalls';
  CSagent?: Maybe<Scalars['String']['output']>;
  createdOn?: Maybe<Scalars['String']['output']>;
  emails?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CustomerNewsletterSettings = {
  __typename?: 'CustomerNewsletterSettings';
  success: Scalars['Boolean']['output'];
};

export type CustomerProfileData = {
  __typename?: 'CustomerProfileData';
  data?: Maybe<Array<Maybe<DataForCustomer>>>;
};

export type CustomerProfileRoot = {
  __typename?: 'CustomerProfileRoot';
  customerProfileSubmitEmailButtonAction?: Maybe<CustomerButtonAction>;
  getCustomerProfileData?: Maybe<CustomerProfileData>;
};

export type CustomerProfileRootCustomerProfileSubmitEmailButtonActionArgs = {
  customerEmail: Scalars['String']['input'];
};

export type CustomerProfileRootGetCustomerProfileDataArgs = {
  customerHash: Scalars['String']['input'];
};

export type CustomerRoot = {
  __typename?: 'CustomerRoot';
  crossSell?: Maybe<CrossSell>;
};

export type CustomerRootCrossSellArgs = {
  email: Scalars['String']['input'];
};

export type CustomerType = {
  __typename?: 'CustomerType';
  customerId?: Maybe<Scalars['String']['output']>;
  customerNotified?: Maybe<Scalars['Boolean']['output']>;
};

export type DamageCase = {
  __typename?: 'DamageCase';
  brandCode?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  damageNumber?: Maybe<Scalars['String']['output']>;
  damageType?: Maybe<Scalars['String']['output']>;
  finalNote?: Maybe<Scalars['String']['output']>;
  formLinks?: Maybe<Array<Maybe<DamageCaseLink>>>;
  history?: Maybe<Array<Maybe<DamageCaseHistory>>>;
  id?: Maybe<Scalars['String']['output']>;
  offer?: Maybe<DamageCaseOffer>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  todoDate?: Maybe<Scalars['String']['output']>;
};

export type DamageCaseContractor = {
  __typename?: 'DamageCaseContractor';
  city?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  oib?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  streetAndHouseNumber?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type DamageCaseCustomer = {
  __typename?: 'DamageCaseCustomer';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type DamageCaseHistory = {
  __typename?: 'DamageCaseHistory';
  adminId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  newValue?: Maybe<Scalars['String']['output']>;
  syncToActivity?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type DamageCaseInput = {
  id: Scalars['String']['input'];
};

export type DamageCaseInsuredPerson = {
  __typename?: 'DamageCaseInsuredPerson';
  city?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  oib?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  streetAndHouseNumber?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type DamageCaseLink = {
  __typename?: 'DamageCaseLink';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type DamageCaseOffer = {
  __typename?: 'DamageCaseOffer';
  contractor?: Maybe<DamageCaseContractor>;
  customer?: Maybe<DamageCaseCustomer>;
  id?: Maybe<Scalars['String']['output']>;
  insuredPerson?: Maybe<DamageCaseInsuredPerson>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  vehicle?: Maybe<DamageCaseVehicle>;
};

export type DamageCaseRoot = {
  __typename?: 'DamageCaseRoot';
  damageCase?: Maybe<Array<Maybe<DamageCase>>>;
  damageCaseById?: Maybe<DamageCase>;
  damageCaseByReferenceId?: Maybe<Array<Maybe<DamageCase>>>;
};

export type DamageCaseRootDamageCaseByIdArgs = {
  id: Scalars['String']['input'];
};

export type DamageCaseRootDamageCaseByReferenceIdArgs = {
  soId: Scalars['String']['input'];
};

export type DamageCaseVehicle = {
  __typename?: 'DamageCaseVehicle';
  chassisNumber?: Maybe<Scalars['String']['output']>;
  maker?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  power?: Maybe<Scalars['String']['output']>;
  powerKw?: Maybe<Scalars['String']['output']>;
  productionYear?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vehicleType?: Maybe<Scalars['String']['output']>;
};

export type DataForCustomer = {
  __typename?: 'DataForCustomer';
  json?: Maybe<Array<Maybe<JsonSets>>>;
  table: Scalars['String']['output'];
};

export type DataForUser = {
  __typename?: 'DataForUser';
  _id: Scalars['String']['output'];
  action?: Maybe<Scalars['String']['output']>;
  buttonLeft?: Maybe<Array<Maybe<WinchV2Button>>>;
  buttonRight?: Maybe<Array<Maybe<WinchV2Button>>>;
  customer?: Maybe<CustomerType>;
  frameData?: Maybe<Scalars['String']['output']>;
  frameLink?: Maybe<Scalars['String']['output']>;
  genStat?: Maybe<Array<Maybe<WinchV2Stats>>>;
  genStatLink?: Maybe<Scalars['String']['output']>;
  info?: Maybe<Array<Maybe<WinchV2Info>>>;
  usrStat?: Maybe<Array<Maybe<WinchV2Stats>>>;
  usrStatLink?: Maybe<Scalars['String']['output']>;
};

export type DataJsonForUser = {
  __typename?: 'DataJsonForUser';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type DatasetConfig = {
  __typename?: 'DatasetConfig';
  key?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Type>;
  value?: Maybe<Scalars['String']['output']>;
};

export type DatasetField = {
  __typename?: 'DatasetField';
  aggregate?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Array<Maybe<DatasetConfig>>>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  mutationArguments?: Maybe<Array<Maybe<MutationArgument>>>;
  sortable?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<SelectValue>>>;
};

export type DatasetFilters = {
  __typename?: 'DatasetFilters';
  appliesToFields?: Maybe<Array<Scalars['String']['output']>>;
  code: Scalars['String']['output'];
  defaultValue?: Maybe<Scalars['String']['output']>;
  executionSide?: Maybe<ExecutionSideEnum>;
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
  values?: Maybe<Array<Maybe<SelectValue>>>;
};

export type DatasetList = {
  __typename?: 'DatasetList';
  datasetCode: Scalars['String']['output'];
  paginationExecutionSide: ExecutionSideEnum;
  sortingExecutionSide: ExecutionSideEnum;
};

export type DatasetMeta = {
  __typename?: 'DatasetMeta';
  datasetCode: Scalars['String']['output'];
  fields?: Maybe<Array<Maybe<DatasetField>>>;
  filters?: Maybe<Array<Maybe<DatasetFilters>>>;
  graphLink?: Maybe<Scalars['String']['output']>;
  maxPageCount?: Maybe<Scalars['Int']['output']>;
  paginationExecutionSide?: Maybe<ExecutionSideEnum>;
  sortingExecutionSide?: Maybe<ExecutionSideEnum>;
  type: DatasetType;
  width?: Maybe<Scalars['Int']['output']>;
};

export type DatasetRecord = {
  __typename?: 'DatasetRecord';
  config?: Maybe<Array<Maybe<DatasetConfig>>>;
  record?: Maybe<Array<Maybe<DatasetRecordField>>>;
};

export type DatasetRecordField = {
  __typename?: 'DatasetRecordField';
  config?: Maybe<Array<Maybe<DatasetConfig>>>;
  key?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Type>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum DatasetType {
  Graph = 'graph',
  Table = 'table',
}

export type DeleteFileAction = {
  __typename?: 'DeleteFileAction';
  msg?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteLog = {
  __typename?: 'DeleteLog';
  date: Scalars['String']['output'];
  email: Scalars['String']['output'];
  field: Scalars['String']['output'];
  id: Scalars['String']['output'];
  number: Scalars['String']['output'];
  what: Scalars['String']['output'];
};

export type DeliveryData = {
  __typename?: 'DeliveryData';
  address?: Maybe<AddressData>;
  deliverTo?: Maybe<Scalars['String']['output']>;
  deliveryType?: Maybe<Scalars['String']['output']>;
};

export type DeliveryEntityEditableValue = {
  __typename?: 'DeliveryEntityEditableValue';
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<DeliveryEntityEnum>;
};

export enum DeliveryEntityEnum {
  Contractor = 'contractor',
  Insured = 'insured',
  Third = 'third',
}

export type Document = {
  __typename?: 'Document';
  _id: Scalars['String']['output'];
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DzoProduct = {
  __typename?: 'DzoProduct';
  brand: Brand;
  code: Scalars['String']['output'];
  coverages?: Maybe<Scalars['String']['output']>;
  drugListB?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orderExternalUrl?: Maybe<Scalars['String']['output']>;
  paymentCoverage: Scalars['String']['output'];
  policyDetails?: Maybe<Array<Maybe<PolicyDetail>>>;
  price: Price;
  specialOffer: Scalars['String']['output'];
};

export type DzoRoot = {
  __typename?: 'DzoRoot';
  product?: Maybe<DzoProduct>;
  products?: Maybe<Array<Maybe<DzoProduct>>>;
};

export type DzoRootProductArgs = {
  birthDate: Scalars['String']['input'];
  brandCode: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
};

export type DzoRootProductsArgs = {
  birthDate: Scalars['String']['input'];
};

export type EditButtonAction = {
  __typename?: 'EditButtonAction';
  msg: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type EditConnectedPropertyAction = {
  __typename?: 'EditConnectedPropertyAction';
  msg: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type EditData = {
  _id: Scalars['String']['input'];
  adminId: Scalars['String']['input'];
  dataViewRequest: Scalars['Boolean']['input'];
  deletedFromSendGrid: Scalars['Boolean']['input'];
  markedAsDoNotContact: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type Email = {
  __typename?: 'Email';
  attachments?: Maybe<Array<Maybe<EmailAttachment>>>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  recipientEmails: Scalars['String']['output'];
  senderEmail: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type EmailAttachment = {
  __typename?: 'EmailAttachment';
  _id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type EmailData = {
  attachments?: InputMaybe<Array<InputMaybe<Attachment>>>;
  body: Scalars['String']['input'];
  receiver: Scalars['String']['input'];
  sender: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type EmailDeleteRoot = {
  __typename?: 'EmailDeleteRoot';
  getRecordById?: Maybe<GetRecordByIdAction>;
  getRecordList?: Maybe<EmailList>;
};

export type EmailDeleteRootGetRecordByIdArgs = {
  recordId: Scalars['String']['input'];
};

export type EmailDeleteRootGetRecordListArgs = {
  filter: Filter;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type EmailList = {
  __typename?: 'EmailList';
  count: Scalars['String']['output'];
  listItems?: Maybe<Array<Maybe<ListItem>>>;
  pages: Scalars['String']['output'];
};

export type EmailParams = {
  __typename?: 'EmailParams';
  adminEmail: Scalars['String']['output'];
  body?: Maybe<Scalars['String']['output']>;
  receiverList: Scalars['String']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  termsAndConditionsLink?: Maybe<Scalars['String']['output']>;
};

export type EvaluationAppRoot = {
  __typename?: 'EvaluationAppRoot';
  evaluation?: Maybe<SingleEvaluation>;
  evaluations?: Maybe<Array<Maybe<SingleEvaluation>>>;
};

export type EvaluationAppRootEvaluationArgs = {
  adminId: Scalars['String']['input'];
  referenceId: Scalars['String']['input'];
  referenceName: Scalars['String']['input'];
};

export type EvaluationAppRootEvaluationsArgs = {
  referenceId: Scalars['String']['input'];
};

export type EvaluationDataInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  callType: Scalars['String']['input'];
  evaluateeId: Scalars['String']['input'];
  evaluatorId: Scalars['String']['input'];
  generalComment?: InputMaybe<Scalars['String']['input']>;
  questionsAndAnswers?: InputMaybe<Array<InputMaybe<QuestionsAndAnswersDataInput>>>;
  referenceId: Scalars['String']['input'];
  referenceName: Scalars['String']['input'];
  soType?: InputMaybe<Scalars['String']['input']>;
};

export enum ExecutionSideEnum {
  Client = 'client',
  Server = 'server',
}

export type Faq = {
  __typename?: 'Faq';
  items?: Maybe<Array<Maybe<FaqItem>>>;
  title: Scalars['String']['output'];
};

export type FaqItem = {
  __typename?: 'FaqItem';
  answer: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  question: Scalars['String']['output'];
  visible: Scalars['Boolean']['output'];
};

export type FaqRoot = {
  __typename?: 'FaqRoot';
  faq?: Maybe<Faq>;
};

export type FaqRootFaqArgs = {
  key: Scalars['String']['input'];
};

export type File = {
  __typename?: 'File';
  _id?: Maybe<Scalars['String']['output']>;
  archiveDate?: Maybe<Scalars['String']['output']>;
  brandId?: Maybe<Scalars['String']['output']>;
  coverages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  history?: Maybe<Array<Maybe<FileHistory>>>;
  name?: Maybe<Scalars['String']['output']>;
  productIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  productTypeIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  src?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type FileAdministrationConfig = {
  __typename?: 'FileAdministrationConfig';
  _id: Scalars['String']['output'];
  config?: Maybe<Array<Maybe<ProductTypeConfig>>>;
  productType?: Maybe<Scalars['String']['output']>;
  productTypeName?: Maybe<Scalars['String']['output']>;
};

export type FileAdministrationRoot = {
  __typename?: 'FileAdministrationRoot';
  getAllAdmins?: Maybe<Array<Maybe<Admin>>>;
  getBrands?: Maybe<Array<Maybe<Brand>>>;
  getDocumentsForBrand?: Maybe<Array<Maybe<File>>>;
  getInitialConfig?: Maybe<Array<Maybe<FileAdministrationConfig>>>;
  getPresignedUrl?: Maybe<PresignedUrlResponse>;
};

export type FileAdministrationRootGetDocumentsForBrandArgs = {
  brandId: Scalars['String']['input'];
  selectedDate: Scalars['String']['input'];
};

export type FileAdministrationRootGetInitialConfigArgs = {
  brandId: Scalars['String']['input'];
};

export type FileData = {
  category?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['String']['input'];
  documentName?: InputMaybe<Scalars['String']['input']>;
};

export type FileHistory = {
  __typename?: 'FileHistory';
  modifiedAt?: Maybe<Scalars['String']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
};

export type FileList = {
  __typename?: 'FileList';
  additionalMessage?: Maybe<Scalars['String']['output']>;
  deletedFilesCount: Scalars['String']['output'];
  files?: Maybe<Array<Maybe<FsFile>>>;
  msg: Scalars['String']['output'];
  relatedFilesCount: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type FileRoot = {
  __typename?: 'FileRoot';
  files?: Maybe<Array<Maybe<File>>>;
};

export type FileRootFilesArgs = {
  referenceId: Scalars['String']['input'];
  referenceName: Scalars['String']['input'];
};

export type FileUploadRoot = {
  __typename?: 'FileUploadRoot';
  getEmailParams?: Maybe<EmailParams>;
  getFilesList?: Maybe<FileList>;
  getRelatedEmails?: Maybe<RelatedEmailsList>;
};

export type FileUploadRootGetEmailParamsArgs = {
  adminId?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<AttachmentIdName>>>;
  brandCode?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  isSendingEpolicy?: InputMaybe<Scalars['Boolean']['input']>;
  modalType?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  referenceName?: InputMaybe<Scalars['String']['input']>;
};

export type FileUploadRootGetFilesListArgs = {
  adminId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  isShowingDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isShowingRelated?: InputMaybe<Scalars['Boolean']['input']>;
  partnersSda?: InputMaybe<Scalars['Boolean']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  referenceName?: InputMaybe<Scalars['String']['input']>;
};

export type FileUploadRootGetRelatedEmailsArgs = {
  referenceId: Scalars['String']['input'];
  referenceName: Scalars['String']['input'];
};

export type Filter = {
  adminActionNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  deletedDone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  markedAsDoNotContact?: InputMaybe<Scalars['String']['input']>;
};

export type FinishPhoneDeleteReviewAction = {
  __typename?: 'FinishPhoneDeleteReviewAction';
  _id?: Maybe<Scalars['String']['output']>;
  adminActionNeeded?: Maybe<Scalars['Boolean']['output']>;
};

export type FinishReviewAction = {
  __typename?: 'FinishReviewAction';
  msg: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Flags = {
  __typename?: 'Flags';
  incomplete?: Maybe<Scalars['Boolean']['output']>;
  isUrgent?: Maybe<Scalars['Boolean']['output']>;
};

export type FlagsInput = {
  isUrgent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FsFile = {
  __typename?: 'FsFile';
  _id: Scalars['String']['output'];
  metadata?: Maybe<Metadata>;
};

export enum Gender {
  F = 'F',
  M = 'M',
}

export type GenderEditableValue = {
  __typename?: 'GenderEditableValue';
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<GenderEnum>;
};

export enum GenderEnum {
  F = 'F',
  M = 'M',
}

export type GetRecordByIdAction = {
  __typename?: 'GetRecordByIdAction';
  email: Scalars['String']['output'];
  results?: Maybe<Array<Maybe<Result>>>;
  reviewEmails?: Maybe<Array<Maybe<ReviewEmails>>>;
  reviewPhones?: Maybe<Array<Maybe<ReviewPhones>>>;
  threeSixtyView: Scalars['String']['output'];
};

export type GoogleReviewRoot = {
  __typename?: 'GoogleReviewRoot';
  testimonials?: Maybe<Array<Maybe<Testimonial>>>;
};

export type GoogleReviewRootTestimonialsArgs = {
  params?: InputMaybe<TestimonialsInput>;
};

export type HealthCalculatorCoverage = {
  __typename?: 'HealthCalculatorCoverage';
  code: Scalars['String']['output'];
  displayForAgent?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
};

export type HealthCalculatorFilterProperties = {
  __typename?: 'HealthCalculatorFilterProperties';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type HealthConsent = {
  CarGiveAway?: InputMaybe<Scalars['Boolean']['input']>;
  allianzGDPR?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  fourteenDayCancellationPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  generalTOSConsent?: InputMaybe<Scalars['Boolean']['input']>;
  healthEmailDocumentationConsent?: InputMaybe<Scalars['Boolean']['input']>;
  healthNeedConsent?: InputMaybe<Scalars['Boolean']['input']>;
  healthValidDataConsent?: InputMaybe<Scalars['Boolean']['input']>;
  kompareHelp?: InputMaybe<Scalars['Boolean']['input']>;
  newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  newsletterSpecialOffers?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HealthOffer = {
  __typename?: 'HealthOffer';
  _id: Scalars['String']['output'];
  acceptedEmailDocumentationDeliveryAt?: Maybe<Scalars['String']['output']>;
  additional?: Maybe<HealthOfferCalcData>;
  allianzGDPRAcceptedAt?: Maybe<Scalars['String']['output']>;
  annotations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  brandId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  funnel?: Maybe<HealthOfferFunnel>;
  iddTermsAcceptedAt?: Maybe<Scalars['String']['output']>;
  isPublished: Scalars['Boolean']['output'];
  linkedProductList?: Maybe<Array<Maybe<HealthOfferLinkedProductList>>>;
  paidAt?: Maybe<Scalars['String']['output']>;
  paymentErrors?: Maybe<Array<Maybe<PaymentError>>>;
  publicOfferId: Scalars['String']['output'];
  publicSoId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  supplementary?: Maybe<HealthOfferCalcData>;
  termsAcceptedAt?: Maybe<Scalars['String']['output']>;
  total?: Maybe<HealthOfferTotalPrice>;
};

export type HealthOfferCalcData = {
  __typename?: 'HealthOfferCalcData';
  actionLabel?: Maybe<Scalars['String']['output']>;
  additionalCoverages?: Maybe<Array<Maybe<CoverageForWeb>>>;
  baseProductPrice?: Maybe<Scalars['Float']['output']>;
  brandCode?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  coverages?: Maybe<Array<Maybe<HealthOfferCoverage>>>;
  discounts?: Maybe<Array<Maybe<HealthOfferDiscount>>>;
  fixedCoverages?: Maybe<Array<Maybe<HealthOfferCoverage>>>;
  includedInPrice?: Maybe<Array<Maybe<CoverageForWeb>>>;
  label?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfInstallments?: Maybe<Scalars['Int']['output']>;
  paymentSlipInfo?: Maybe<PaymentSlipInfo>;
  priceChangeModifier?: Maybe<HealthOfferPriceChangeModifier>;
  total?: Maybe<HealthOfferTotalPrice>;
  visual?: Maybe<HealthProductVisual>;
  voucherPriceChangeModifier?: Maybe<VoucherPriceChangeModifier>;
  voucherPriceModifier?: Maybe<VoucherPriceModifier>;
};

export type HealthOfferCalculationDataCoverageInput = {
  gratis: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type HealthOfferCalculationDataDiscountInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type HealthOfferCalculationDataInput = {
  code: Scalars['String']['input'];
  coverages?: InputMaybe<Array<InputMaybe<HealthOfferCalculationDataCoverageInput>>>;
  discounts?: InputMaybe<Array<InputMaybe<HealthOfferCalculationDataDiscountInput>>>;
  priceChangeModifier: HealthOfferCalculationPriceChangeModifierInput;
  voucherPriceChangeModifier?: InputMaybe<VoucherPriceChangeModifierInput>;
  voucherPriceModifier?: InputMaybe<VoucherPriceModifierInput>;
};

export enum HealthOfferCalculationPriceChangeModifierEnum {
  Fixed = 'fixed',
  Percentage = 'percentage',
}

export type HealthOfferCalculationPriceChangeModifierInput = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  type: HealthOfferCalculationPriceChangeModifierEnum;
};

export type HealthOfferCoverage = {
  __typename?: 'HealthOfferCoverage';
  code?: Maybe<Scalars['String']['output']>;
  disabledErrors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  gratis?: Maybe<HealthOfferCoverageGratis>;
  label?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<HealthOfferCoverageOptions>>>;
  price?: Maybe<Scalars['Float']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferCoverageGratis = {
  __typename?: 'HealthOfferCoverageGratis';
  disabledErrors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type HealthOfferCoverageOptions = {
  __typename?: 'HealthOfferCoverageOptions';
  disabledErrors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  key?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferData = {
  __typename?: 'HealthOfferData';
  contractor?: Maybe<HealthOfferDataContractor>;
  delivery?: Maybe<HealthOfferDataDelivery>;
  insuredPerson?: Maybe<HealthOfferDataInsuredPerson>;
  karenca?: Maybe<Scalars['Boolean']['output']>;
  newPolicyStartDate?: Maybe<Scalars['String']['output']>;
  newPolicyStartDateNote?: Maybe<Scalars['String']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferDataContractor = {
  __typename?: 'HealthOfferDataContractor';
  company?: Maybe<HealthOfferDataContractorCompany>;
  isSamePerson?: Maybe<Scalars['Boolean']['output']>;
  person?: Maybe<HealthOfferDataContractorPerson>;
  personType?: Maybe<PersonTypeEnum>;
};

export type HealthOfferDataContractorCompany = {
  __typename?: 'HealthOfferDataContractorCompany';
  city?: Maybe<StringEditableValue>;
  cityKompareId?: Maybe<StringEditableValue>;
  companyName?: Maybe<StringEditableValue>;
  houseNumber?: Maybe<StringEditableValue>;
  oib?: Maybe<StringEditableValue>;
  partnerContactEmail?: Maybe<StringEditableValue>;
  street?: Maybe<StringEditableValue>;
  streetAndHouseNumber?: Maybe<StringEditableValue>;
  streetKompareId?: Maybe<StringEditableValue>;
  zipCode?: Maybe<IntEditableValue>;
};

export type HealthOfferDataContractorCompanyInput = {
  city: Scalars['String']['input'];
  cityKompareId?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  houseNumber: Scalars['String']['input'];
  oib: Scalars['String']['input'];
  partnerContactEmail?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  streetAndHouseNumber: Scalars['String']['input'];
  streetKompareId?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['Int']['input'];
};

export type HealthOfferDataContractorInput = {
  company?: InputMaybe<HealthOfferDataContractorCompanyInput>;
  isSamePerson: Scalars['Boolean']['input'];
  person?: InputMaybe<HealthOfferDataContractorPersonInput>;
  personType: PersonTypeEnum;
};

export type HealthOfferDataContractorPerson = {
  __typename?: 'HealthOfferDataContractorPerson';
  birthDate?: Maybe<StringEditableValue>;
  city?: Maybe<StringEditableValue>;
  cityKompareId?: Maybe<StringEditableValue>;
  firstName?: Maybe<StringEditableValue>;
  gender?: Maybe<GenderEditableValue>;
  houseNumber?: Maybe<StringEditableValue>;
  lastName?: Maybe<StringEditableValue>;
  oib?: Maybe<StringEditableValue>;
  partnerContactEmail?: Maybe<StringEditableValue>;
  street?: Maybe<StringEditableValue>;
  streetAndHouseNumber?: Maybe<StringEditableValue>;
  streetKompareId?: Maybe<StringEditableValue>;
  zipCode?: Maybe<IntEditableValue>;
};

export type HealthOfferDataContractorPersonInput = {
  birthDate?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityKompareId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderEnum>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  oib?: InputMaybe<Scalars['String']['input']>;
  partnerContactEmail?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetAndHouseNumber?: InputMaybe<Scalars['String']['input']>;
  streetKompareId?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['Int']['input']>;
};

export type HealthOfferDataDelivery = {
  __typename?: 'HealthOfferDataDelivery';
  asEntity?: Maybe<DeliveryEntityEditableValue>;
  city?: Maybe<StringEditableValue>;
  cityKompareId?: Maybe<StringEditableValue>;
  houseNumber?: Maybe<StringEditableValue>;
  name?: Maybe<StringEditableValue>;
  street?: Maybe<StringEditableValue>;
  streetAndHouseNumber?: Maybe<StringEditableValue>;
  streetKompareId?: Maybe<StringEditableValue>;
  zipCode?: Maybe<IntEditableValue>;
};

export type HealthOfferDataDeliveryInput = {
  asEntity: DeliveryEntityEnum;
  city?: InputMaybe<Scalars['String']['input']>;
  cityKompareId?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetAndHouseNumber?: InputMaybe<Scalars['String']['input']>;
  streetKompareId?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['Int']['input']>;
};

export type HealthOfferDataInsuredPerson = {
  __typename?: 'HealthOfferDataInsuredPerson';
  birthDate?: Maybe<StringEditableValue>;
  city?: Maybe<StringEditableValue>;
  cityKompareId?: Maybe<StringEditableValue>;
  firstName?: Maybe<StringEditableValue>;
  gender?: Maybe<GenderEditableValue>;
  houseNumber?: Maybe<StringEditableValue>;
  insuranceNumber?: Maybe<StringEditableValue>;
  lastName?: Maybe<StringEditableValue>;
  oib?: Maybe<StringEditableValue>;
  partnerContactEmail?: Maybe<StringEditableValue>;
  personalIdIssuer?: Maybe<StringEditableValue>;
  personalIdNumber?: Maybe<StringEditableValue>;
  street?: Maybe<StringEditableValue>;
  streetAndHouseNumber?: Maybe<StringEditableValue>;
  streetKompareId?: Maybe<StringEditableValue>;
  zipCode?: Maybe<IntEditableValue>;
};

export type HealthOfferDataInsuredPersonInput = {
  city: Scalars['String']['input'];
  cityKompareId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<GenderEnum>;
  houseNumber: Scalars['String']['input'];
  insuranceNumber?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  oib: Scalars['String']['input'];
  partnerContactEmail?: InputMaybe<Scalars['String']['input']>;
  personalIdIssuer?: InputMaybe<Scalars['String']['input']>;
  personalIdNumber?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  streetAndHouseNumber?: InputMaybe<Scalars['String']['input']>;
  streetKompareId?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['Int']['input'];
};

export type HealthOfferDiscount = {
  __typename?: 'HealthOfferDiscount';
  code?: Maybe<Scalars['String']['output']>;
  disabledErrors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  label?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<HealthOfferCoverageOptions>>>;
  tooltip?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferFunnel = {
  __typename?: 'HealthOfferFunnel';
  latestStep?: Maybe<HealthOfferFunnelStep>;
  steps?: Maybe<Array<Maybe<HealthOfferFunnelStep>>>;
};

export type HealthOfferFunnelStep = {
  __typename?: 'HealthOfferFunnelStep';
  code?: Maybe<Scalars['String']['output']>;
  openedAt?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferGeneralTransferDetails = {
  __typename?: 'HealthOfferGeneralTransferDetails';
  customerAddress?: Maybe<Scalars['String']['output']>;
  customerCity?: Maybe<Scalars['String']['output']>;
  customerCountry?: Maybe<Scalars['String']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerFirstName?: Maybe<Scalars['String']['output']>;
  customerLastName?: Maybe<Scalars['String']['output']>;
  customerOib?: Maybe<Scalars['String']['output']>;
  customerPhone?: Maybe<Scalars['String']['output']>;
  customerZipCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  numberOfInstallments?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  recipientAccountNumber?: Maybe<Scalars['String']['output']>;
  recipientAddress?: Maybe<Scalars['String']['output']>;
  recipientCity?: Maybe<Scalars['String']['output']>;
  recipientName?: Maybe<Scalars['String']['output']>;
  recipientZipCode?: Maybe<Scalars['String']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  referenceNumberType?: Maybe<Scalars['String']['output']>;
  referencePrefix?: Maybe<Scalars['String']['output']>;
  referenceSuffix?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferIsPublishedNewValue = {
  __typename?: 'HealthOfferIsPublishedNewValue';
  isPublished: Scalars['Boolean']['output'];
};

export type HealthOfferLinkedProductList = {
  __typename?: 'HealthOfferLinkedProductList';
  config?: Maybe<HealthOfferCalcData>;
  disabledErrors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferPaymentInstallment = {
  __typename?: 'HealthOfferPaymentInstallment';
  amount: Scalars['Float']['output'];
  installment: Scalars['Int']['output'];
  paymentTypeDiscount?: Maybe<Scalars['Float']['output']>;
};

export type HealthOfferPaymentOption = {
  __typename?: 'HealthOfferPaymentOption';
  paymentOption: Scalars['String']['output'];
  paymentSlipInfo?: Maybe<PaymentSlipInfo>;
  paymentTypes?: Maybe<Array<Maybe<HealthOfferPaymentType>>>;
};

export enum HealthOfferPaymentOptionEnum {
  Aircash = 'aircash',
  CreditCard = 'creditCard',
  CreditCardWithInstallments = 'creditCardWithInstallments',
  GeneralTransfer = 'generalTransfer',
  GeneralTransferWithInstallments = 'generalTransferWithInstallments',
  KeksPay = 'keksPay',
}

export type HealthOfferPaymentOptionResponse = {
  __typename?: 'HealthOfferPaymentOptionResponse';
  offer?: Maybe<HealthOffer>;
  paymentOptions?: Maybe<Array<Maybe<HealthOfferPaymentOption>>>;
};

export type HealthOfferPaymentType = {
  __typename?: 'HealthOfferPaymentType';
  installments?: Maybe<Array<Maybe<HealthOfferPaymentInstallment>>>;
  paymentType: Scalars['String']['output'];
  paymentTypeLabel?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferPriceChangeModifier = {
  __typename?: 'HealthOfferPriceChangeModifier';
  amount?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferPriceModifier = {
  __typename?: 'HealthOfferPriceModifier';
  amount?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  multiplier?: Maybe<Scalars['Float']['output']>;
};

export type HealthOfferPublishedAction = {
  __typename?: 'HealthOfferPublishedAction';
  newValue: Scalars['String']['output'];
  offerId: Scalars['String']['output'];
};

export type HealthOfferTotalPrice = {
  __typename?: 'HealthOfferTotalPrice';
  creditCard?: Maybe<Scalars['Float']['output']>;
  creditCardWithInstallments?: Maybe<Scalars['Float']['output']>;
  generalTransfer?: Maybe<Scalars['Float']['output']>;
  generalTransferWithInstallments?: Maybe<Scalars['Float']['output']>;
};

export type HealthOfferWsPayDetails = {
  __typename?: 'HealthOfferWSPayDetails';
  CancelURL?: Maybe<Scalars['String']['output']>;
  CreditCardName?: Maybe<Scalars['String']['output']>;
  CustomerAddress?: Maybe<Scalars['String']['output']>;
  CustomerCity?: Maybe<Scalars['String']['output']>;
  CustomerCountry?: Maybe<Scalars['String']['output']>;
  CustomerEmail?: Maybe<Scalars['String']['output']>;
  CustomerFirstName?: Maybe<Scalars['String']['output']>;
  CustomerLastName?: Maybe<Scalars['String']['output']>;
  CustomerPhone?: Maybe<Scalars['String']['output']>;
  CustomerZIP?: Maybe<Scalars['String']['output']>;
  Iframe?: Maybe<Scalars['String']['output']>;
  IframeResponseTarget?: Maybe<Scalars['String']['output']>;
  PaymentMethod?: Maybe<Scalars['String']['output']>;
  PaymentPlan?: Maybe<Scalars['String']['output']>;
  ReturnErrorURL?: Maybe<Scalars['String']['output']>;
  ReturnURL?: Maybe<Scalars['String']['output']>;
  ShopID?: Maybe<Scalars['String']['output']>;
  ShoppingCartID?: Maybe<Scalars['String']['output']>;
  Signature?: Maybe<Scalars['String']['output']>;
  TotalAmount?: Maybe<Scalars['String']['output']>;
};

export type HealthPrice = {
  __typename?: 'HealthPrice';
  additionalCoveragesMessage?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  priceWithCoverages?: Maybe<Scalars['Float']['output']>;
};

export type HealthProduct = {
  __typename?: 'HealthProduct';
  calculatorFilterProperties?: Maybe<Array<Maybe<HealthCalculatorFilterProperties>>>;
  code: Scalars['String']['output'];
  coverages?: Maybe<Array<Maybe<HealthCalculatorCoverage>>>;
  fixedCoverages?: Maybe<Array<Maybe<HealthCalculatorCoverage>>>;
  label?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  participationCoverage?: Maybe<Scalars['String']['output']>;
  priceWithoutDiscounts?: Maybe<Scalars['Float']['output']>;
  prices?: Maybe<HealthOfferTotalPrice>;
  sortPriority?: Maybe<Scalars['Int']['output']>;
  visual?: Maybe<HealthProductVisual>;
};

export type HealthProductDocuments = {
  __typename?: 'HealthProductDocuments';
  name?: Maybe<Scalars['String']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type HealthProductList = {
  __typename?: 'HealthProductList';
  defer?: Maybe<Array<Maybe<HealthProductListItem>>>;
  expedite?: Maybe<Array<Maybe<HealthProductListItem>>>;
};

export type HealthProductListItem = {
  __typename?: 'HealthProductListItem';
  calculationCode: Scalars['String']['output'];
  label: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
};

export enum HealthProductTypeCodeEnum {
  Additional = 'ADDITIONAL',
  Supplementary = 'SUPPLEMENTARY',
}

export type HealthProductVisual = {
  __typename?: 'HealthProductVisual';
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  highlight?: Maybe<Scalars['Boolean']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
};

export type HealthProductsInput = {
  birthDate: Scalars['String']['input'];
  coverages: Array<InputMaybe<Scalars['String']['input']>>;
  productTypeCode: HealthProductTypeCodeEnum;
  requestedProducts: Array<InputMaybe<RequestedHealthProductsInput>>;
};

export type HealthRoot = {
  __typename?: 'HealthRoot';
  checkoutHealthOffer?: Maybe<HealthOffer>;
  checkoutHealthOfferAdminLink?: Maybe<LinkTranslation>;
  checkoutHealthOfferBasicConsentCheck?: Maybe<CheckoutHealthOfferBasicConsentCheck>;
  checkoutHealthOfferData?: Maybe<HealthOfferData>;
  checkoutHealthOfferDocuments?: Maybe<Array<Maybe<HealthProductDocuments>>>;
  checkoutHealthOfferFrontLink?: Maybe<LinkTranslation>;
  checkoutHealthOfferGeneralTransferDetails?: Maybe<HealthOfferGeneralTransferDetails>;
  checkoutHealthOfferPaymentOptions?: Maybe<HealthOfferPaymentOptionResponse>;
  checkoutHealthOfferWSPayPaymentDetails?: Maybe<HealthOfferWsPayDetails>;
  checkoutHealthOffers?: Maybe<Array<Maybe<HealthOffer>>>;
  healthOffer?: Maybe<HealthOffer>;
  healthOffers?: Maybe<Array<Maybe<HealthOffer>>>;
  healthProductList?: Maybe<HealthProductList>;
  healthProducts?: Maybe<Array<Maybe<HealthProduct>>>;
  webCalculationsSupplementary?: Maybe<Array<Maybe<WebCalculationForProduct>>>;
};

export type HealthRootCheckoutHealthOfferArgs = {
  offerId: Scalars['String']['input'];
};

export type HealthRootCheckoutHealthOfferAdminLinkArgs = {
  link: Scalars['String']['input'];
};

export type HealthRootCheckoutHealthOfferBasicConsentCheckArgs = {
  offerId?: InputMaybe<Scalars['String']['input']>;
  soId?: InputMaybe<Scalars['String']['input']>;
};

export type HealthRootCheckoutHealthOfferDataArgs = {
  offerId: Scalars['String']['input'];
};

export type HealthRootCheckoutHealthOfferDocumentsArgs = {
  offerId: Scalars['String']['input'];
};

export type HealthRootCheckoutHealthOfferFrontLinkArgs = {
  link: Scalars['String']['input'];
};

export type HealthRootCheckoutHealthOfferGeneralTransferDetailsArgs = {
  installments: Scalars['Int']['input'];
  offerId: Scalars['String']['input'];
};

export type HealthRootCheckoutHealthOfferPaymentOptionsArgs = {
  offerId: Scalars['String']['input'];
};

export type HealthRootCheckoutHealthOfferWsPayPaymentDetailsArgs = {
  installments: Scalars['Int']['input'];
  offerId: Scalars['String']['input'];
  paymentOption: HealthOfferPaymentOptionEnum;
  paymentType: Scalars['String']['input'];
};

export type HealthRootCheckoutHealthOffersArgs = {
  soId: Scalars['String']['input'];
};

export type HealthRootHealthOfferArgs = {
  offerId: Scalars['String']['input'];
};

export type HealthRootHealthOffersArgs = {
  soId: Scalars['String']['input'];
};

export type HealthRootHealthProductListArgs = {
  productTypeCode: HealthProductTypeCodeEnum;
};

export type HealthRootHealthProductsArgs = {
  params: HealthProductsInput;
};

export type HealthRootWebCalculationsSupplementaryArgs = {
  birthDate: Scalars['String']['input'];
};

export type HeartbeatConfirm = {
  __typename?: 'HeartbeatConfirm';
  confirm?: Maybe<Scalars['Boolean']['output']>;
};

export type HistoryData = {
  __typename?: 'HistoryData';
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type HuoData = {
  __typename?: 'HuoData';
  canExtendPolicy?: Maybe<Scalars['String']['output']>;
  checkoutEligible?: Maybe<Scalars['String']['output']>;
  checksPassed?: Maybe<Scalars['String']['output']>;
  checksSkipped?: Maybe<Scalars['String']['output']>;
  numDamages?: Maybe<Scalars['String']['output']>;
  policyCheck?: Maybe<Scalars['String']['output']>;
  solCheck?: Maybe<Scalars['String']['output']>;
  vehicleModel?: Maybe<Scalars['String']['output']>;
};

export type InputData = {
  createdAt: Scalars['String']['input'];
  createdBy: Scalars['String']['input'];
  dataViewRequest: Scalars['Boolean']['input'];
  deletedDone?: InputMaybe<Scalars['String']['input']>;
  deletedFromSendGrid: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  markedAsDoNotContact: Scalars['String']['input'];
  note: Scalars['String']['input'];
  reportedAt: Scalars['String']['input'];
  reportedTo: Scalars['String']['input'];
  reportedVia: Scalars['String']['input'];
};

export type InsertAdminInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  alternateStartDate?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  custodiaID?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  emailName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  kompareID?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneExt?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
};

export type InsertCustomerCrossSellNoteInput = {
  adminToken: Scalars['String']['input'];
  email: Scalars['String']['input'];
  interested: Scalars['String']['input'];
  message: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type IntEditableValue = {
  __typename?: 'IntEditableValue';
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type JsonSets = {
  __typename?: 'JsonSets';
  record?: Maybe<Array<Maybe<DataJsonForUser>>>;
};

export type KompareRider = {
  __typename?: 'KompareRider';
  _id: Scalars['ID']['output'];
  brandCode?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  documents: Array<Maybe<Document>>;
  internalDescription: Scalars['String']['output'];
  label: Scalars['String']['output'];
  modifiedAt?: Maybe<Scalars['String']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  modifiedByName?: Maybe<Scalars['String']['output']>;
  productType: Scalars['String']['output'];
};

export type LaqoData = {
  __typename?: 'LaqoData';
  bonusIncluded: Scalars['Boolean']['output'];
  calculation?: Maybe<Array<Maybe<LaqoPricesList>>>;
};

export type LaqoParams = {
  bonusProtect: Scalars['Boolean']['input'];
  cacheOnly: Scalars['Boolean']['input'];
  kasko: Scalars['Boolean']['input'];
  offerId: Scalars['String']['input'];
};

export type LaqoPrices = {
  __typename?: 'LaqoPrices';
  data?: Maybe<LaqoData>;
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type LaqoPricesList = {
  __typename?: 'LaqoPricesList';
  amount?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LeadInput = {
  birthDate: Scalars['String']['input'];
  brandCode?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
};

export type LinkTranslation = {
  __typename?: 'LinkTranslation';
  id?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type LinkedRegistration = {
  __typename?: 'LinkedRegistration';
  adjustedExpDate?: Maybe<Scalars['String']['output']>;
  bonusMalus?: Maybe<Scalars['String']['output']>;
  daysToExp?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  vehicleModel?: Maybe<Scalars['String']['output']>;
};

export type ListItem = {
  __typename?: 'ListItem';
  _id: Scalars['String']['output'];
  adminActionNeeded?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  dataViewRequest: Scalars['Boolean']['output'];
  deletedDone?: Maybe<Scalars['String']['output']>;
  deletedFromSendGrid: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  markedAsDoNotContact: Scalars['String']['output'];
  note: Scalars['String']['output'];
  reportedAt: Scalars['String']['output'];
  reportedTo: Scalars['String']['output'];
  reportedVia: Scalars['String']['output'];
};

export type LogAoAdminErrorLogInput = {
  adminId?: InputMaybe<Scalars['String']['input']>;
  brandCode?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  errorStackTrace?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  retryCount?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type MessageData = {
  __typename?: 'MessageData';
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  note: Scalars['String']['output'];
};

export type MetaDataInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  archiveDate: Scalars['String']['input'];
  brandId: Scalars['String']['input'];
  coverages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedBy: Scalars['String']['input'];
  name: Scalars['String']['input'];
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  replacerString: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type Metadata = {
  __typename?: 'Metadata';
  category: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  documentName: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  offerLink: Scalars['String']['output'];
  referenceId: Scalars['String']['output'];
  referenceName: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type ModifiedByAgentData = {
  __typename?: 'ModifiedByAgentData';
  vehicleOwner?: Maybe<VehicleOwnerData>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addNewKompareRiderFile?: Maybe<KompareRider>;
  addNewPartnerRiderFile?: Maybe<PartnerRider>;
  assignAdminTeamleader: Admin;
  callMe?: Maybe<Scalars['Boolean']['output']>;
  changeTicketStatus?: Maybe<ChangeTicketStatus>;
  checkAndApplyVoucherCode?: Maybe<HealthOffer>;
  checkoutAcceptBasicConsents?: Maybe<Scalars['Boolean']['output']>;
  confirmCheckoutWSPaySignature?: Maybe<ConfirmCheckoutWsPaySignatureResponse>;
  createCheckoutHealthOffer?: Maybe<Scalars['String']['output']>;
  createCheckoutHealthSO?: Maybe<Scalars['String']['output']>;
  createDamageCaseByReferenceId: DamageCase;
  createEvaluation?: Maybe<SingleEvaluation>;
  createHealthOffer?: Maybe<HealthOffer>;
  createNote?: Maybe<Note>;
  createSupportEvaluation?: Maybe<SingleSupportEvaluation>;
  createTicket?: Maybe<Ticket>;
  createTicketMessage?: Maybe<TicketMessage>;
  customerProfileSubmitEmailButtonAction?: Maybe<CustomerButtonAction>;
  deleteFileAction?: Maybe<DeleteFileAction>;
  deleteHealthOffer?: Maybe<Scalars['String']['output']>;
  deleteProperties?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  duplicateHealthOffer?: Maybe<HealthOffer>;
  editButtonAction?: Maybe<EditButtonAction>;
  editConnectedProperty?: Maybe<EditConnectedPropertyAction>;
  finishPhoneDeleteReview?: Maybe<FinishPhoneDeleteReviewAction>;
  finishReview?: Maybe<FinishReviewAction>;
  generateNewsletterLink?: Maybe<CustomerNewsletterSettings>;
  insertAdmin: Admin;
  insertCallRecordingNotification: Scalars['Boolean']['output'];
  insertCustomerCrossSellNote: Scalars['Boolean']['output'];
  insertLead: Scalars['Boolean']['output'];
  logAoAdminError: Scalars['Boolean']['output'];
  modifyHealthOfferIsPublished?: Maybe<HealthOfferIsPublishedNewValue>;
  removeAdmin: Scalars['Boolean']['output'];
  removeVoucherCode?: Maybe<HealthOffer>;
  saveConsent?: Maybe<Scalars['Boolean']['output']>;
  saveEditAction?: Maybe<SaveEditAction>;
  saveTermsAndConditionsDocument?: Maybe<File>;
  sdaAppletAction: SdaAppletActionNewValue;
  sdaKaskoPolicyIssuingAction?: Maybe<Scalars['String']['output']>;
  sendEmailAction?: Maybe<SendEmailAction>;
  sendGeneralTransferDetailsToEmail?: Maybe<Scalars['Boolean']['output']>;
  sendOfferAccepted?: Maybe<Scalars['Boolean']['output']>;
  sendOffersToEmail?: Maybe<Scalars['Boolean']['output']>;
  sendSms: Scalars['Boolean']['output'];
  setAdminStatus: Admin;
  setAsArchived?: Maybe<Ticket>;
  setCheckoutPaymentAttempt?: Maybe<Scalars['Boolean']['output']>;
  setCheckoutPaymentErrors?: Maybe<Scalars['Boolean']['output']>;
  setInsuranceNumber?: Maybe<Scalars['Boolean']['output']>;
  submitPhoneDeleteRecordAction?: Maybe<RecordData>;
  submitRecordAction?: Maybe<SubmitRecordAction>;
  updateAdmin: Admin;
  updateAdminAssignment: Admin;
  updateAdminRole: Admin;
  updateCheckoutHealthOfferData?: Maybe<Scalars['Boolean']['output']>;
  updateDamageCase: DamageCase;
  updateDamageCaseInfo: DamageCase;
  updateEvaluation?: Maybe<SingleEvaluation>;
  updateHealthOfferCalculationData?: Maybe<HealthOffer>;
  updateKompareRider?: Maybe<KompareRider>;
  updateNewsletterSettings?: Maybe<SaveNewsletterToCustomer>;
  updatePartnerRider?: Maybe<PartnerRider>;
  updateSupportEvaluation?: Maybe<SingleSupportEvaluation>;
  winchAssignLimit: Scalars['Int']['output'];
  winchButtonAction: ButtonAction;
};

export type MutationAddNewKompareRiderFileArgs = {
  newName: Scalars['String']['input'];
  oldName: Scalars['String']['input'];
  riderCode: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type MutationAddNewPartnerRiderFileArgs = {
  newName: Scalars['String']['input'];
  oldName: Scalars['String']['input'];
  riderCode: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type MutationAssignAdminTeamleaderArgs = {
  params: AdminAssignTeamleaderInput;
};

export type MutationCallMeArgs = {
  callMeInput?: InputMaybe<CallMeInput>;
};

export type MutationChangeTicketStatusArgs = {
  createdBy: Scalars['String']['input'];
  status: Scalars['String']['input'];
  ticketId: Scalars['String']['input'];
};

export type MutationCheckAndApplyVoucherCodeArgs = {
  offerId: Scalars['String']['input'];
  voucherCode: Scalars['String']['input'];
};

export type MutationCheckoutAcceptBasicConsentsArgs = {
  customerId: Scalars['String']['input'];
};

export type MutationConfirmCheckoutWsPaySignatureArgs = {
  params: ConfirmCheckoutWsPaySignatureInput;
};

export type MutationCreateCheckoutHealthOfferArgs = {
  birthDate: Scalars['String']['input'];
  coverages?: InputMaybe<Array<Scalars['String']['input']>>;
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
  productTypeCode: Scalars['String']['input'];
  soId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateCheckoutHealthSoArgs = {
  birthDate: Scalars['String']['input'];
  consents?: InputMaybe<Array<InputMaybe<HealthConsent>>>;
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  productTypeCode: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateDamageCaseByReferenceIdArgs = {
  id: Scalars['String']['input'];
};

export type MutationCreateEvaluationArgs = {
  adminId: Scalars['String']['input'];
  params?: InputMaybe<EvaluationDataInput>;
};

export type MutationCreateHealthOfferArgs = {
  coverages?: InputMaybe<Array<Scalars['String']['input']>>;
  productCode: Scalars['String']['input'];
  soId: Scalars['String']['input'];
};

export type MutationCreateNoteArgs = {
  params?: InputMaybe<NoteInput>;
};

export type MutationCreateSupportEvaluationArgs = {
  adminId: Scalars['String']['input'];
  params?: InputMaybe<SupportEvaluationDataInput>;
};

export type MutationCreateTicketArgs = {
  params?: InputMaybe<TicketDataInput>;
};

export type MutationCreateTicketMessageArgs = {
  params?: InputMaybe<TicketMessageDataInput>;
};

export type MutationCustomerProfileSubmitEmailButtonActionArgs = {
  customerEmail: Scalars['String']['input'];
};

export type MutationDeleteFileActionArgs = {
  adminId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
};

export type MutationDeleteHealthOfferArgs = {
  offerId: Scalars['String']['input'];
};

export type MutationDeletePropertiesArgs = {
  adminId?: InputMaybe<Scalars['String']['input']>;
  deleteLogIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recordId?: InputMaybe<Scalars['String']['input']>;
  shouldDeleteProperty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationDuplicateHealthOfferArgs = {
  offerId: Scalars['String']['input'];
};

export type MutationEditButtonActionArgs = {
  editData: EditData;
};

export type MutationEditConnectedPropertyArgs = {
  action: Scalars['String']['input'];
  adminId: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
  property: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type MutationFinishPhoneDeleteReviewArgs = {
  recordId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationFinishReviewArgs = {
  adminId: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
};

export type MutationGenerateNewsletterLinkArgs = {
  email: Scalars['String']['input'];
};

export type MutationInsertAdminArgs = {
  params: InsertAdminInput;
};

export type MutationInsertCallRecordingNotificationArgs = {
  adminId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
};

export type MutationInsertCustomerCrossSellNoteArgs = {
  params: InsertCustomerCrossSellNoteInput;
};

export type MutationInsertLeadArgs = {
  lead: LeadInput;
};

export type MutationLogAoAdminErrorArgs = {
  params: LogAoAdminErrorLogInput;
};

export type MutationModifyHealthOfferIsPublishedArgs = {
  newValue: Scalars['Boolean']['input'];
  offerId: Scalars['String']['input'];
};

export type MutationRemoveAdminArgs = {
  params: RemoveAdminInput;
};

export type MutationRemoveVoucherCodeArgs = {
  offerId: Scalars['String']['input'];
};

export type MutationSaveConsentArgs = {
  params?: InputMaybe<ConsentInput>;
};

export type MutationSaveEditActionArgs = {
  adminId: Scalars['String']['input'];
  fileData: FileData;
};

export type MutationSaveTermsAndConditionsDocumentArgs = {
  params?: InputMaybe<MetaDataInput>;
};

export type MutationSdaAppletActionArgs = {
  params: SdaAppletActionInput;
};

export type MutationSdaKaskoPolicyIssuingActionArgs = {
  params: SdaKaskoPolicyIssuingActionInput;
};

export type MutationSendEmailActionArgs = {
  adminId: Scalars['String']['input'];
  emailData: EmailData;
  isSendingEpolicy: Scalars['Boolean']['input'];
  referenceId: Scalars['String']['input'];
  referenceName: Scalars['String']['input'];
  shouldZipFiles: Scalars['Boolean']['input'];
};

export type MutationSendGeneralTransferDetailsToEmailArgs = {
  installments: Scalars['Int']['input'];
  offerId: Scalars['String']['input'];
};

export type MutationSendOfferAcceptedArgs = {
  offerId: Scalars['String']['input'];
};

export type MutationSendOffersToEmailArgs = {
  birthDate: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type MutationSendSmsArgs = {
  params: SendSmsInput;
};

export type MutationSetAdminStatusArgs = {
  params: AdminStatus;
};

export type MutationSetAsArchivedArgs = {
  ticketId: Scalars['String']['input'];
};

export type MutationSetCheckoutPaymentAttemptArgs = {
  offerId: Scalars['String']['input'];
};

export type MutationSetCheckoutPaymentErrorsArgs = {
  errors: Array<InputMaybe<Scalars['String']['input']>>;
  offerId: Scalars['String']['input'];
};

export type MutationSetInsuranceNumberArgs = {
  insuranceNumber: Scalars['String']['input'];
  soId: Scalars['String']['input'];
};

export type MutationSubmitPhoneDeleteRecordActionArgs = {
  adminId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  referenceName?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSubmitRecordActionArgs = {
  adminId: Scalars['String']['input'];
  inputData: InputData;
};

export type MutationUpdateAdminArgs = {
  params: UpdateAdminInput;
};

export type MutationUpdateAdminAssignmentArgs = {
  params: UpdateAdminAssignmentInput;
};

export type MutationUpdateAdminRoleArgs = {
  params: UpdateAdminRoleInput;
};

export type MutationUpdateCheckoutHealthOfferDataArgs = {
  params: CheckoutHealthOfferDataInput;
};

export type MutationUpdateDamageCaseArgs = {
  params: UpdateDamageCaseInput;
};

export type MutationUpdateDamageCaseInfoArgs = {
  params: UpdateDamageCaseInfoInput;
};

export type MutationUpdateEvaluationArgs = {
  _id: Scalars['String']['input'];
  adminId: Scalars['String']['input'];
  params?: InputMaybe<EvaluationDataInput>;
};

export type MutationUpdateHealthOfferCalculationDataArgs = {
  additional?: InputMaybe<HealthOfferCalculationDataInput>;
  offerId: Scalars['String']['input'];
  supplementary?: InputMaybe<HealthOfferCalculationDataInput>;
};

export type MutationUpdateKompareRiderArgs = {
  code: Scalars['String']['input'];
  updateRiderInput: UpdateRiderInput;
};

export type MutationUpdateNewsletterSettingsArgs = {
  hashLink: Scalars['String']['input'];
  newsletterSettings: NewsletterDataInput;
};

export type MutationUpdatePartnerRiderArgs = {
  code: Scalars['String']['input'];
  updateRiderInput: UpdateRiderInput;
};

export type MutationUpdateSupportEvaluationArgs = {
  _id: Scalars['String']['input'];
  adminId: Scalars['String']['input'];
  params?: InputMaybe<SupportEvaluationDataInput>;
};

export type MutationWinchAssignLimitArgs = {
  type: WinchAssignType;
};

export type MutationWinchButtonActionArgs = {
  adminId: Scalars['String']['input'];
  rmEndpoint: Scalars['String']['input'];
};

export type MutationArgument = {
  __typename?: 'MutationArgument';
  name: Scalars['String']['output'];
  source: MutationArgumentSourceEnum;
};

export enum MutationArgumentSourceEnum {
  Date = 'date',
  Email = 'email',
  Record = 'record',
  Text = 'text',
}

export type NewPolicyData = {
  __typename?: 'NewPolicyData';
  beginsAt?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
};

export type NewsletterDataInput = {
  newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  newsletterSpecialOffers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NewsletterHashedLink = {
  __typename?: 'NewsletterHashedLink';
  email?: Maybe<Scalars['String']['output']>;
  newsletterSettings?: Maybe<NewsletterSettingObject>;
};

export type NewsletterHashedLinkInput = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
};

export type NewsletterHashedLinkRoot = {
  __typename?: 'NewsletterHashedLinkRoot';
  newsletterSettingsByHashedLink?: Maybe<NewsletterHashedLink>;
};

export type NewsletterHashedLinkRootNewsletterSettingsByHashedLinkArgs = {
  hashLink: Scalars['String']['input'];
};

export type NewsletterSettingObject = {
  __typename?: 'NewsletterSettingObject';
  newsletter?: Maybe<Scalars['Boolean']['output']>;
  newsletterSpecialOffers?: Maybe<Scalars['Boolean']['output']>;
};

export type Note = {
  __typename?: 'Note';
  createdAt?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  noteType?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  referenceName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type NoteInput = {
  note: Scalars['String']['input'];
  referenceId: Scalars['String']['input'];
  referenceName: Scalars['String']['input'];
};

export type NoteRoot = {
  __typename?: 'NoteRoot';
  notes?: Maybe<Array<Maybe<Note>>>;
};

export type NoteRootNotesArgs = {
  referenceId: Scalars['String']['input'];
  referenceName: Scalars['String']['input'];
};

export type Offer = {
  __typename?: 'Offer';
  bonusMalus?: Maybe<Scalars['String']['output']>;
  newPolicy?: Maybe<NewPolicyData>;
  registration: Scalars['String']['output'];
  sharedData?: Maybe<SharedData>;
  status?: Maybe<Scalars['String']['output']>;
};

export type OldPolicyData = {
  __typename?: 'OldPolicyData';
  beginsAt?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['String']['output']>;
  insuranceCompany?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  renewalStatus?: Maybe<Scalars['String']['output']>;
};

export type PartnerRider = {
  __typename?: 'PartnerRider';
  brandCode: Scalars['String']['output'];
  brandName: Scalars['String']['output'];
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  documents: Array<Maybe<Document>>;
  groupCode: Scalars['String']['output'];
  internalDescription: Scalars['String']['output'];
  label: Scalars['String']['output'];
  modifiedAt?: Maybe<Scalars['String']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  modifiedByName?: Maybe<Scalars['String']['output']>;
  productType: Scalars['String']['output'];
};

export type PaymentError = {
  __typename?: 'PaymentError';
  createdAt?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
};

export type PaymentSlipInfo = {
  __typename?: 'PaymentSlipInfo';
  amount?: Maybe<Scalars['Float']['output']>;
  numOfInstallments?: Maybe<Scalars['Int']['output']>;
};

export type PersonData = {
  __typename?: 'PersonData';
  address?: Maybe<AddressData>;
  birthDate?: Maybe<Scalars['String']['output']>;
  companyContactFirstName?: Maybe<Scalars['String']['output']>;
  companyContactLastName?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyType?: Maybe<Scalars['String']['output']>;
  disability?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  licenseYearsWithoutDamages?: Maybe<Scalars['String']['output']>;
  oib?: Maybe<Scalars['String']['output']>;
};

export enum PersonTypeEnum {
  Company = 'company',
  Person = 'person',
}

export type Phone = {
  __typename?: 'Phone';
  phone: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type PhoneDeleteFilter = {
  adminActionNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type PhoneDeleteRoot = {
  __typename?: 'PhoneDeleteRoot';
  getRecordById?: Maybe<RecordById>;
  getRecordList?: Maybe<PhoneList>;
};

export type PhoneDeleteRootGetRecordByIdArgs = {
  adminId?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['String']['input']>;
};

export type PhoneDeleteRootGetRecordListArgs = {
  filter: PhoneDeleteFilter;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type PhoneList = {
  __typename?: 'PhoneList';
  count?: Maybe<Scalars['String']['output']>;
  listItems?: Maybe<Array<Maybe<PhoneListItem>>>;
  pages?: Maybe<Scalars['String']['output']>;
};

export type PhoneListItem = {
  __typename?: 'PhoneListItem';
  _id: Scalars['String']['output'];
  adminActionNeeded?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  deleteLog?: Maybe<Array<Maybe<PhonesToDeleteDeleteLog>>>;
  deletedDone?: Maybe<Scalars['Boolean']['output']>;
  note: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type PhoneRoot = {
  __typename?: 'PhoneRoot';
  phone?: Maybe<Array<Maybe<Phone>>>;
};

export type PhoneRootPhoneArgs = {
  email: Scalars['String']['input'];
};

export type PhonesToDeleteDeleteLog = {
  __typename?: 'PhonesToDeleteDeleteLog';
  ID?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  reviewDone?: Maybe<Scalars['Boolean']['output']>;
  what?: Maybe<Scalars['String']['output']>;
};

export type PolicyData = {
  __typename?: 'PolicyData';
  expirationDate?: Maybe<Scalars['Int']['output']>;
  expirationDateTime?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  requestedExpirationDate?: Maybe<Scalars['String']['output']>;
};

export type PolicyIssuingDataInput = {
  id: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type PresignedUrlForFileUpload = {
  __typename?: 'PresignedUrlForFileUpload';
  randomString: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PresignedUrlResponse = {
  __typename?: 'PresignedUrlResponse';
  randomString: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Price = {
  __typename?: 'Price';
  amount: Scalars['Float']['output'];
  promotion: Scalars['Boolean']['output'];
  promotionDescription?: Maybe<Scalars['String']['output']>;
};

export type ProductData = {
  __typename?: 'ProductData';
  referenceId: Scalars['String']['output'];
  referenceName: Scalars['String']['output'];
};

export type ProductList = {
  __typename?: 'ProductList';
  defer?: Maybe<Array<Maybe<ProductListItem>>>;
  expedite?: Maybe<Array<Maybe<ProductListItem>>>;
};

export type ProductListInput = {
  vehicleType: Scalars['String']['input'];
};

export type ProductListItem = {
  __typename?: 'ProductListItem';
  brandCode: Scalars['String']['output'];
  calculationCode: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type ProductTypeConfig = {
  __typename?: 'ProductTypeConfig';
  productCode?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  value?: Maybe<ProductTypeValueConfig>;
};

export type ProductTypeCoverage = {
  __typename?: 'ProductTypeCoverage';
  code?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ProductTypeValueConfig = {
  __typename?: 'ProductTypeValueConfig';
  _id?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  coverages?: Maybe<Array<Maybe<ProductTypeCoverage>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ProductsInput = {
  bonusForCalculator?: InputMaybe<Scalars['Int']['input']>;
  isQuick: Scalars['String']['input'];
  isShowingPriceWithMaxCommissionDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  kasko: Scalars['Boolean']['input'];
  kaskoWithFranchise?: InputMaybe<Scalars['Boolean']['input']>;
  offerId: Scalars['String']['input'];
  passengerCoverageCode: Scalars['Int']['input'];
  paymentType: Scalars['String']['input'];
  requestedProducts: Array<InputMaybe<RequestedProductsInput>>;
  requiredCoverages: Array<InputMaybe<Scalars['String']['input']>>;
};

export type PublicAdmin = {
  __typename?: 'PublicAdmin';
  avatar?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneExt?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  admin: AdminRoot;
  adminRoleDefinition: AdminRoleDefinitionRoot;
  ao: AoRoot;
  aoRiders: AoRidersRoot;
  callOrder: CallOrderRoot;
  communicationApp: CommunicationAppRoot;
  customer: CustomerRoot;
  customerProfile: CustomerProfileRoot;
  damageCase: DamageCaseRoot;
  dzo: DzoRoot;
  emailDelete: EmailDeleteRoot;
  evaluationApp: EvaluationAppRoot;
  faq: FaqRoot;
  file: FileRoot;
  fileAdministration: FileAdministrationRoot;
  fileUpload: FileUploadRoot;
  googleReview: GoogleReviewRoot;
  health: HealthRoot;
  newsletterHashedLink: NewsletterHashedLinkRoot;
  note: NoteRoot;
  phone: PhoneRoot;
  phoneDelete: PhoneDeleteRoot;
  report: ReportRoot;
  smsTemplate: SmsTemplateRoot;
  supportEvaluationApp: SupportEvaluationAppRoot;
  winchActiveAgents: WinchActiveAgentsRoot;
  winchV2: WinchV2Root;
};

export type QuestionsAndAnswersData = {
  __typename?: 'QuestionsAndAnswersData';
  answer?: Maybe<Scalars['Int']['output']>;
  cantEvaluate?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type QuestionsAndAnswersDataInput = {
  answer?: InputMaybe<Scalars['Int']['input']>;
  cantEvaluate?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type RecordById = {
  __typename?: 'RecordById';
  record?: Maybe<RecordData>;
};

export type RecordData = {
  __typename?: 'RecordData';
  _id?: Maybe<Scalars['String']['output']>;
  adminActionNeeded?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deleteLog?: Maybe<Array<Maybe<PhonesToDeleteDeleteLog>>>;
  deletedDone?: Maybe<Scalars['Boolean']['output']>;
  modifiedAt?: Maybe<Scalars['String']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  referenceName?: Maybe<Scalars['String']['output']>;
};

export type RegistrationAssignments = {
  __typename?: 'RegistrationAssignments';
  adminName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
};

export type RegistrationData = {
  __typename?: 'RegistrationData';
  number?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
};

export type RegistrationHistory = {
  __typename?: 'RegistrationHistory';
  chassis?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  insuranceCompany?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paidAmount?: Maybe<Scalars['String']['output']>;
  paidOfferLink?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<Scalars['String']['output']>;
};

export type RelatedEmailsList = {
  __typename?: 'RelatedEmailsList';
  relatedEmailList?: Maybe<Array<Maybe<Email>>>;
};

export type RemoveAdminInput = {
  id: Scalars['String']['input'];
};

export type Report = {
  __typename?: 'Report';
  datasetList?: Maybe<Array<Maybe<DatasetList>>>;
  groupName: Scalars['String']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  isSubscribable?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  menuDescription?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<ReportPayload>;
  pollInterval?: Maybe<Scalars['Int']['output']>;
  reportCode: Scalars['String']['output'];
  subGroupName: Scalars['String']['output'];
  usersDescription?: Maybe<Scalars['String']['output']>;
};

export type ReportData = {
  __typename?: 'ReportData';
  meta?: Maybe<DatasetMeta>;
  records?: Maybe<Array<Maybe<DatasetRecord>>>;
};

export type ReportInput = {
  modifiers?: InputMaybe<Array<InputMaybe<ReportModifiersInput>>>;
  reportCode: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ReportMeta = {
  __typename?: 'ReportMeta';
  counter?: Maybe<ReportMetaCounter>;
};

export type ReportMetaCounter = {
  __typename?: 'ReportMetaCounter';
  hot?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ReportModifiersFiltersInput = {
  code: Scalars['String']['input'];
  filterValue: Scalars['String']['input'];
};

export type ReportModifiersInput = {
  datasetCode: Scalars['String']['input'];
  filters?: InputMaybe<Array<InputMaybe<ReportModifiersFiltersInput>>>;
  pageNumber: Scalars['Int']['input'];
  sortField?: InputMaybe<SortFieldInput>;
};

export type ReportPayload = {
  __typename?: 'ReportPayload';
  data?: Maybe<Array<Maybe<ReportData>>>;
  meta?: Maybe<ReportMeta>;
};

export type ReportRoot = {
  __typename?: 'ReportRoot';
  report?: Maybe<Report>;
  reports?: Maybe<Array<Maybe<Report>>>;
};

export type ReportRootReportArgs = {
  params: ReportInput;
};

export type ReportRootReportsArgs = {
  params: UserInput;
};

export type RequestedHealthProductsInput = {
  calculationCode?: InputMaybe<Scalars['String']['input']>;
  productCode?: InputMaybe<Scalars['String']['input']>;
};

export type RequestedProductsInput = {
  brandCode?: InputMaybe<Scalars['String']['input']>;
  calculationCode?: InputMaybe<Scalars['String']['input']>;
};

export type Result = {
  __typename?: 'Result';
  deleteLog?: Maybe<DeleteLog>;
};

export type ReviewEmails = {
  __typename?: 'ReviewEmails';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
};

export type ReviewPhones = {
  __typename?: 'ReviewPhones';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ReviewReplyData = {
  __typename?: 'ReviewReplyData';
  comment?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
};

export type ReviewerData = {
  __typename?: 'ReviewerData';
  displayName?: Maybe<Scalars['String']['output']>;
  profilePhotoUrl?: Maybe<Scalars['String']['output']>;
};

export type Role = {
  __typename?: 'Role';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SaveEditAction = {
  __typename?: 'SaveEditAction';
  msg?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveNewsletterToCustomer = {
  __typename?: 'SaveNewsletterToCustomer';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SdaAppletActionInput = {
  appletData?: InputMaybe<Array<InputMaybe<AppletDataInput>>>;
  appletKey: Scalars['String']['input'];
  appletName: Scalars['String']['input'];
  reportCode: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type SdaAppletActionNewValue = {
  __typename?: 'SdaAppletActionNewValue';
  newValue?: Maybe<Scalars['String']['output']>;
};

export type SdaKaskoPolicyIssuingActionInput = {
  appletData: Array<InputMaybe<PolicyIssuingDataInput>>;
  offerId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type SelectValue = {
  __typename?: 'SelectValue';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SendEmailAction = {
  __typename?: 'SendEmailAction';
  msg: Scalars['String']['output'];
};

export type SendSmsInput = {
  adminId: Scalars['String']['input'];
  message: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type SharedData = {
  __typename?: 'SharedData';
  additionalData?: Maybe<AdditionalData>;
  calculationData?: Maybe<CalculationData>;
  contractor?: Maybe<PersonData>;
  customerType?: Maybe<Scalars['String']['output']>;
  deliverGreenCard?: Maybe<Scalars['Boolean']['output']>;
  deliverOriginalPolicy?: Maybe<Scalars['Boolean']['output']>;
  delivery?: Maybe<DeliveryData>;
  oldPolicy?: Maybe<OldPolicyData>;
  owner?: Maybe<PersonData>;
};

export type SingleEvaluation = {
  __typename?: 'SingleEvaluation';
  _id?: Maybe<Scalars['String']['output']>;
  callType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  evaluateeId?: Maybe<Scalars['String']['output']>;
  evaluatorId?: Maybe<Scalars['String']['output']>;
  generalComment?: Maybe<Scalars['String']['output']>;
  questionsAndAnswers?: Maybe<Array<Maybe<QuestionsAndAnswersData>>>;
  referenceId?: Maybe<Scalars['String']['output']>;
  referenceName?: Maybe<Scalars['String']['output']>;
  soType?: Maybe<Scalars['String']['output']>;
};

export type SingleSupportEvaluation = {
  __typename?: 'SingleSupportEvaluation';
  _id?: Maybe<Scalars['String']['output']>;
  callType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  evaluateeId?: Maybe<Scalars['String']['output']>;
  evaluatorId?: Maybe<Scalars['String']['output']>;
  generalComment?: Maybe<Scalars['String']['output']>;
  linkToCall?: Maybe<Scalars['String']['output']>;
  questionsAndAnswers?: Maybe<Array<Maybe<SupportQuestionsAndAnswersData>>>;
  referenceId?: Maybe<Scalars['String']['output']>;
  referenceName?: Maybe<Scalars['String']['output']>;
};

export type Sms = {
  __typename?: 'Sms';
  adminId?: Maybe<Scalars['String']['output']>;
  cleanPhone?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  internalId?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SmsTemplate = {
  __typename?: 'SmsTemplate';
  body: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SmsTemplateRoot = {
  __typename?: 'SmsTemplateRoot';
  smsTemplate?: Maybe<Array<Maybe<SmsTemplate>>>;
};

export type SmsTemplateRootSmsTemplateArgs = {
  productCode: Scalars['String']['input'];
};

export enum SortDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type SortFieldInput = {
  direction: SortDirectionEnum;
  field: Scalars['String']['input'];
};

export type StringEditableValue = {
  __typename?: 'StringEditableValue';
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SubmitPhoneDeleteRecordAction = {
  __typename?: 'SubmitPhoneDeleteRecordAction';
  message: Scalars['String']['output'];
};

export type SubmitRecordAction = {
  __typename?: 'SubmitRecordAction';
  msg: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SupportEvaluationAppRoot = {
  __typename?: 'SupportEvaluationAppRoot';
  supportEvaluations?: Maybe<Array<Maybe<SingleSupportEvaluation>>>;
};

export type SupportEvaluationAppRootSupportEvaluationsArgs = {
  _id?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  referenceName?: InputMaybe<Scalars['String']['input']>;
};

export type SupportEvaluationDataInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  callType: Scalars['String']['input'];
  evaluateeId: Scalars['String']['input'];
  evaluatorId: Scalars['String']['input'];
  generalComment?: InputMaybe<Scalars['String']['input']>;
  linkToCall?: InputMaybe<Scalars['String']['input']>;
  questionsAndAnswers?: InputMaybe<Array<InputMaybe<SupportQuestionsAndAnswersDataInput>>>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  referenceName?: InputMaybe<Scalars['String']['input']>;
};

export type SupportQuestionsAndAnswersData = {
  __typename?: 'SupportQuestionsAndAnswersData';
  answer?: Maybe<Scalars['Int']['output']>;
  cantEvaluate?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type SupportQuestionsAndAnswersDataInput = {
  answer?: InputMaybe<Scalars['Int']['input']>;
  cantEvaluate?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type Testimonial = {
  __typename?: 'Testimonial';
  comment?: Maybe<Scalars['String']['output']>;
  createTime?: Maybe<Scalars['String']['output']>;
  createTimeString?: Maybe<Scalars['String']['output']>;
  reviewId?: Maybe<Scalars['String']['output']>;
  reviewReply?: Maybe<ReviewReplyData>;
  reviewer?: Maybe<ReviewerData>;
  starRating?: Maybe<Scalars['String']['output']>;
};

export type TestimonialsInput = {
  lastYearOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  random?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Ticket = {
  __typename?: 'Ticket';
  _id: Scalars['String']['output'];
  assignedTo?: Maybe<Scalars['String']['output']>;
  category?: Maybe<CategoryData>;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Flags>;
  history?: Maybe<Array<Maybe<HistoryData>>>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  messages?: Maybe<Array<Maybe<MessageData>>>;
  product?: Maybe<ProductData>;
  status: Scalars['String']['output'];
};

export type TicketCategory = {
  __typename?: 'TicketCategory';
  categoryName: Scalars['String']['output'];
  categoryType?: Maybe<Array<Maybe<CategoryType>>>;
  label: Scalars['String']['output'];
  subCategory?: Maybe<Array<Maybe<TicketSubcategory>>>;
};

export type TicketDataInput = {
  adminId?: InputMaybe<Scalars['String']['input']>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  categoryType?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<FlagsInput>;
  note: Scalars['String']['input'];
  referenceId: Scalars['String']['input'];
  referenceName: Scalars['String']['input'];
  subCategory?: InputMaybe<Scalars['String']['input']>;
};

export type TicketMessage = {
  __typename?: 'TicketMessage';
  _id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<MessageData>;
};

export type TicketMessageDataInput = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  note: Scalars['String']['input'];
  ticketId: Scalars['String']['input'];
};

export type TicketSubcategory = {
  __typename?: 'TicketSubcategory';
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type TimeLimitedOffer = {
  __typename?: 'TimeLimitedOffer';
  code: Scalars['String']['output'];
  defaultAmount: Scalars['Int']['output'];
  priceModifierCode: Scalars['String']['output'];
  timeLimitedAmount: Scalars['Int']['output'];
};

export enum Type {
  Boolean = 'boolean',
  Number = 'number',
  String = 'string',
  Unknown = 'unknown',
}

export type UpdateAdminAssignmentInput = {
  id: Scalars['String']['input'];
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAdminInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  alternateStartDate?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  custodiaID?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  emailName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  id: Scalars['String']['input'];
  kompareID?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneExt?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAdminRoleInput = {
  id: Scalars['String']['input'];
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDamageCaseInfoInput = {
  damageNumber?: InputMaybe<Scalars['String']['input']>;
  damageType?: InputMaybe<Scalars['String']['input']>;
  finalNote?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  policyNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDamageCaseInput = {
  id: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  syncToActivity?: InputMaybe<Scalars['Boolean']['input']>;
  todoDate?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRiderInput = {
  description: Scalars['String']['input'];
  documentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  internalDescription: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

export type UserInput = {
  id: Scalars['String']['input'];
};

export type VehicleData = {
  __typename?: 'VehicleData';
  chassisNumber?: Maybe<Scalars['String']['output']>;
  dateOfFirstRegistration?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  powerKw?: Maybe<Scalars['String']['output']>;
  productionYear?: Maybe<Scalars['String']['output']>;
  seatsNumber?: Maybe<Scalars['String']['output']>;
  vehicleMotorType?: Maybe<Scalars['String']['output']>;
  vehiclePurpose?: Maybe<Scalars['String']['output']>;
  vehicleType?: Maybe<Scalars['String']['output']>;
};

export type VehicleOwnerData = {
  __typename?: 'VehicleOwnerData';
  birthDate?: Maybe<Scalars['String']['output']>;
  disability?: Maybe<Scalars['String']['output']>;
  licenseYearsWithoutDamages?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type VoucherPriceChangeModifier = {
  __typename?: 'VoucherPriceChangeModifier';
  amount?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type VoucherPriceChangeModifierInput = {
  amount: Scalars['Float']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<HealthOfferCalculationPriceChangeModifierEnum>;
};

export type VoucherPriceModifier = {
  __typename?: 'VoucherPriceModifier';
  amount?: Maybe<Scalars['Float']['output']>;
};

export type VoucherPriceModifierInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
};

export type WebCalculationForProduct = {
  __typename?: 'WebCalculationForProduct';
  actionLabel?: Maybe<Scalars['String']['output']>;
  additionalCoverages: Array<Maybe<CoverageForWeb>>;
  brandName: Scalars['String']['output'];
  includedInPrice: Array<Maybe<CoverageForWeb>>;
  logo: Scalars['String']['output'];
  price: CalculationPrice;
  productCode: Scalars['String']['output'];
  productLabel: Scalars['String']['output'];
};

export type WinchActiveAgentsRoot = {
  __typename?: 'WinchActiveAgentsRoot';
  heartbeat?: Maybe<HeartbeatConfirm>;
};

export type WinchActiveAgentsRootHeartbeatArgs = {
  adminId: Scalars['String']['input'];
  productTypeId: Scalars['String']['input'];
};

export enum WinchAssignType {
  OnlyMy = 'onlyMy',
  OnlyNew = 'onlyNew',
}

export type WinchSingleStat = {
  __typename?: 'WinchSingleStat';
  _id?: Maybe<Scalars['String']['output']>;
};

export type WinchStats = {
  __typename?: 'WinchStats';
  forwardIds?: Maybe<Array<Maybe<WinchSingleStat>>>;
};

export type WinchV2Button = {
  __typename?: 'WinchV2Button';
  link?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type WinchV2Info = {
  __typename?: 'WinchV2Info';
  link?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type WinchV2Root = {
  __typename?: 'WinchV2Root';
  buttonAction?: Maybe<ButtonAction>;
  getForUser?: Maybe<DataForUser>;
  winchAdminCalls?: Maybe<AdminCallsData>;
  winchStats?: Maybe<WinchStats>;
};

export type WinchV2RootButtonActionArgs = {
  adminId: Scalars['String']['input'];
  rmEndpoint: Scalars['String']['input'];
};

export type WinchV2RootGetForUserArgs = {
  adminId: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
};

export type WinchV2RootWinchAdminCallsArgs = {
  adminId: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
};

export type WinchV2RootWinchStatsArgs = {
  adminId?: InputMaybe<Scalars['String']['input']>;
  productTypeId: Scalars['String']['input'];
};

export type WinchV2Stats = {
  __typename?: 'WinchV2Stats';
  blink?: Maybe<Scalars['Boolean']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type PolicyDetail = {
  __typename?: 'policyDetail';
  icon: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type WinchActiveAgents = {
  __typename?: 'winchActiveAgents';
  adminId: Scalars['String']['output'];
  productTypeId: Scalars['String']['output'];
};

export type CallMeMutationVariables = Exact<{
  callMeInput: CallMeInput;
}>;

export type CallMeMutation = { __typename?: 'Mutation'; callMe?: boolean | null };

export type CheckAndApplyVoucherCodeMutationVariables = Exact<{
  voucherCode: Scalars['String']['input'];
  offerId: Scalars['String']['input'];
}>;

export type CheckAndApplyVoucherCodeMutation = {
  __typename?: 'Mutation';
  checkAndApplyVoucherCode?: {
    __typename?: 'HealthOffer';
    _id: string;
    publicSoId: string;
    status: string;
    brandId?: string | null;
    publicOfferId: string;
    annotations?: Array<string | null> | null;
    supplementary?: {
      __typename?: 'HealthOfferCalcData';
      label?: string | null;
      brandName?: string | null;
      brandCode?: string | null;
      numberOfInstallments?: number | null;
      code?: string | null;
      logoUrl?: string | null;
      priceChangeModifier?: {
        __typename?: 'HealthOfferPriceChangeModifier';
        amount?: number | null;
        type?: string | null;
        description?: string | null;
      } | null;
      voucherPriceModifier?: { __typename?: 'VoucherPriceModifier'; amount?: number | null } | null;
      voucherPriceChangeModifier?: {
        __typename?: 'VoucherPriceChangeModifier';
        amount?: number | null;
        type?: string | null;
        description?: string | null;
        code?: string | null;
      } | null;
      visual?: {
        __typename?: 'HealthProductVisual';
        highlight?: boolean | null;
        tooltip?: string | null;
        description?: string | null;
      } | null;
      fixedCoverages?: Array<{
        __typename?: 'HealthOfferCoverage';
        label?: string | null;
        tooltip?: string | null;
        value?: string | null;
        price?: number | null;
        gratis?: { __typename?: 'HealthOfferCoverageGratis'; value?: boolean | null; type?: string | null } | null;
        options?: Array<{
          __typename?: 'HealthOfferCoverageOptions';
          key?: string | null;
          value?: string | null;
        } | null> | null;
      } | null> | null;
      coverages?: Array<{
        __typename?: 'HealthOfferCoverage';
        label?: string | null;
        tooltip?: string | null;
        value?: string | null;
        price?: number | null;
        gratis?: { __typename?: 'HealthOfferCoverageGratis'; value?: boolean | null; type?: string | null } | null;
        options?: Array<{
          __typename?: 'HealthOfferCoverageOptions';
          key?: string | null;
          value?: string | null;
        } | null> | null;
      } | null> | null;
      discounts?: Array<{
        __typename?: 'HealthOfferDiscount';
        value?: string | null;
        tooltip?: string | null;
      } | null> | null;
      paymentSlipInfo?: {
        __typename?: 'PaymentSlipInfo';
        amount?: number | null;
        numOfInstallments?: number | null;
      } | null;
      total?: {
        __typename?: 'HealthOfferTotalPrice';
        generalTransfer?: number | null;
        generalTransferWithInstallments?: number | null;
        creditCard?: number | null;
        creditCardWithInstallments?: number | null;
      } | null;
      includedInPrice?: Array<{ __typename?: 'CoverageForWeb'; label: string; description: string } | null> | null;
      additionalCoverages?: Array<{ __typename?: 'CoverageForWeb'; label: string; description: string } | null> | null;
    } | null;
    additional?: {
      __typename?: 'HealthOfferCalcData';
      label?: string | null;
      brandName?: string | null;
      brandCode?: string | null;
      numberOfInstallments?: number | null;
      code?: string | null;
      logoUrl?: string | null;
      priceChangeModifier?: {
        __typename?: 'HealthOfferPriceChangeModifier';
        amount?: number | null;
        type?: string | null;
        description?: string | null;
      } | null;
      voucherPriceModifier?: { __typename?: 'VoucherPriceModifier'; amount?: number | null } | null;
      visual?: {
        __typename?: 'HealthProductVisual';
        highlight?: boolean | null;
        tooltip?: string | null;
        description?: string | null;
      } | null;
      coverages?: Array<{
        __typename?: 'HealthOfferCoverage';
        label?: string | null;
        tooltip?: string | null;
        value?: string | null;
        price?: number | null;
        gratis?: { __typename?: 'HealthOfferCoverageGratis'; value?: boolean | null; type?: string | null } | null;
        options?: Array<{
          __typename?: 'HealthOfferCoverageOptions';
          key?: string | null;
          value?: string | null;
        } | null> | null;
      } | null> | null;
      fixedCoverages?: Array<{
        __typename?: 'HealthOfferCoverage';
        label?: string | null;
        tooltip?: string | null;
        value?: string | null;
        price?: number | null;
        gratis?: { __typename?: 'HealthOfferCoverageGratis'; value?: boolean | null; type?: string | null } | null;
        options?: Array<{
          __typename?: 'HealthOfferCoverageOptions';
          key?: string | null;
          value?: string | null;
        } | null> | null;
      } | null> | null;
      discounts?: Array<{
        __typename?: 'HealthOfferDiscount';
        value?: string | null;
        tooltip?: string | null;
      } | null> | null;
      total?: {
        __typename?: 'HealthOfferTotalPrice';
        generalTransfer?: number | null;
        generalTransferWithInstallments?: number | null;
        creditCard?: number | null;
        creditCardWithInstallments?: number | null;
      } | null;
      includedInPrice?: Array<{ __typename?: 'CoverageForWeb'; label: string; description: string } | null> | null;
      additionalCoverages?: Array<{ __typename?: 'CoverageForWeb'; label: string; description: string } | null> | null;
    } | null;
    total?: {
      __typename?: 'HealthOfferTotalPrice';
      generalTransfer?: number | null;
      generalTransferWithInstallments?: number | null;
      creditCard?: number | null;
      creditCardWithInstallments?: number | null;
    } | null;
  } | null;
};

export type ConfirmCheckoutWsPaySignatureMutationVariables = Exact<{
  params: ConfirmCheckoutWsPaySignatureInput;
}>;

export type ConfirmCheckoutWsPaySignatureMutation = {
  __typename?: 'Mutation';
  confirmCheckoutWSPaySignature?: {
    __typename?: 'ConfirmCheckoutWSPaySignatureResponse';
    success?: boolean | null;
    alreadyPaid?: boolean | null;
  } | null;
};

export type CreateCheckoutHealthSoMutationVariables = Exact<{
  birthDate: Scalars['String']['input'];
  email: Scalars['String']['input'];
  productTypeCode: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  consents?: InputMaybe<Array<InputMaybe<HealthConsent>> | InputMaybe<HealthConsent>>;
}>;

export type CreateCheckoutHealthSoMutation = { __typename?: 'Mutation'; createCheckoutHealthSO?: string | null };

export type CreateCheckoutHealthOfferMutationVariables = Exact<{
  soId?: InputMaybe<Scalars['String']['input']>;
  birthDate: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  productTypeCode: Scalars['String']['input'];
  productCode: Scalars['String']['input'];
  coverages?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type CreateCheckoutHealthOfferMutation = { __typename?: 'Mutation'; createCheckoutHealthOffer?: string | null };

export type RemoveVoucherCodeMutationVariables = Exact<{
  offerId: Scalars['String']['input'];
}>;

export type RemoveVoucherCodeMutation = {
  __typename?: 'Mutation';
  removeVoucherCode?: {
    __typename?: 'HealthOffer';
    _id: string;
    publicSoId: string;
    status: string;
    brandId?: string | null;
    publicOfferId: string;
    annotations?: Array<string | null> | null;
    supplementary?: {
      __typename?: 'HealthOfferCalcData';
      label?: string | null;
      brandName?: string | null;
      brandCode?: string | null;
      numberOfInstallments?: number | null;
      code?: string | null;
      logoUrl?: string | null;
      priceChangeModifier?: {
        __typename?: 'HealthOfferPriceChangeModifier';
        amount?: number | null;
        type?: string | null;
        description?: string | null;
      } | null;
      voucherPriceModifier?: { __typename?: 'VoucherPriceModifier'; amount?: number | null } | null;
      voucherPriceChangeModifier?: {
        __typename?: 'VoucherPriceChangeModifier';
        amount?: number | null;
        type?: string | null;
        description?: string | null;
        code?: string | null;
      } | null;
      visual?: {
        __typename?: 'HealthProductVisual';
        highlight?: boolean | null;
        tooltip?: string | null;
        description?: string | null;
      } | null;
      fixedCoverages?: Array<{
        __typename?: 'HealthOfferCoverage';
        label?: string | null;
        tooltip?: string | null;
        value?: string | null;
        price?: number | null;
        gratis?: { __typename?: 'HealthOfferCoverageGratis'; value?: boolean | null; type?: string | null } | null;
        options?: Array<{
          __typename?: 'HealthOfferCoverageOptions';
          key?: string | null;
          value?: string | null;
        } | null> | null;
      } | null> | null;
      coverages?: Array<{
        __typename?: 'HealthOfferCoverage';
        label?: string | null;
        tooltip?: string | null;
        value?: string | null;
        price?: number | null;
        gratis?: { __typename?: 'HealthOfferCoverageGratis'; value?: boolean | null; type?: string | null } | null;
        options?: Array<{
          __typename?: 'HealthOfferCoverageOptions';
          key?: string | null;
          value?: string | null;
        } | null> | null;
      } | null> | null;
      discounts?: Array<{
        __typename?: 'HealthOfferDiscount';
        value?: string | null;
        tooltip?: string | null;
      } | null> | null;
      paymentSlipInfo?: {
        __typename?: 'PaymentSlipInfo';
        amount?: number | null;
        numOfInstallments?: number | null;
      } | null;
      total?: {
        __typename?: 'HealthOfferTotalPrice';
        generalTransfer?: number | null;
        generalTransferWithInstallments?: number | null;
        creditCard?: number | null;
        creditCardWithInstallments?: number | null;
      } | null;
      includedInPrice?: Array<{ __typename?: 'CoverageForWeb'; label: string; description: string } | null> | null;
      additionalCoverages?: Array<{ __typename?: 'CoverageForWeb'; label: string; description: string } | null> | null;
    } | null;
    additional?: {
      __typename?: 'HealthOfferCalcData';
      label?: string | null;
      brandName?: string | null;
      brandCode?: string | null;
      numberOfInstallments?: number | null;
      code?: string | null;
      logoUrl?: string | null;
      priceChangeModifier?: {
        __typename?: 'HealthOfferPriceChangeModifier';
        amount?: number | null;
        type?: string | null;
        description?: string | null;
      } | null;
      voucherPriceModifier?: { __typename?: 'VoucherPriceModifier'; amount?: number | null } | null;
      visual?: {
        __typename?: 'HealthProductVisual';
        highlight?: boolean | null;
        tooltip?: string | null;
        description?: string | null;
      } | null;
      coverages?: Array<{
        __typename?: 'HealthOfferCoverage';
        label?: string | null;
        tooltip?: string | null;
        value?: string | null;
        price?: number | null;
        gratis?: { __typename?: 'HealthOfferCoverageGratis'; value?: boolean | null; type?: string | null } | null;
        options?: Array<{
          __typename?: 'HealthOfferCoverageOptions';
          key?: string | null;
          value?: string | null;
        } | null> | null;
      } | null> | null;
      fixedCoverages?: Array<{
        __typename?: 'HealthOfferCoverage';
        label?: string | null;
        tooltip?: string | null;
        value?: string | null;
        price?: number | null;
        gratis?: { __typename?: 'HealthOfferCoverageGratis'; value?: boolean | null; type?: string | null } | null;
        options?: Array<{
          __typename?: 'HealthOfferCoverageOptions';
          key?: string | null;
          value?: string | null;
        } | null> | null;
      } | null> | null;
      discounts?: Array<{
        __typename?: 'HealthOfferDiscount';
        value?: string | null;
        tooltip?: string | null;
      } | null> | null;
      total?: {
        __typename?: 'HealthOfferTotalPrice';
        generalTransfer?: number | null;
        generalTransferWithInstallments?: number | null;
        creditCard?: number | null;
        creditCardWithInstallments?: number | null;
      } | null;
      includedInPrice?: Array<{ __typename?: 'CoverageForWeb'; label: string; description: string } | null> | null;
      additionalCoverages?: Array<{ __typename?: 'CoverageForWeb'; label: string; description: string } | null> | null;
    } | null;
    total?: {
      __typename?: 'HealthOfferTotalPrice';
      generalTransfer?: number | null;
      generalTransferWithInstallments?: number | null;
      creditCard?: number | null;
      creditCardWithInstallments?: number | null;
    } | null;
  } | null;
};

export type SaveConsentMutationVariables = Exact<{
  params: ConsentInput;
}>;

export type SaveConsentMutation = { __typename?: 'Mutation'; saveConsent?: boolean | null };

export type SendGeneralTransferDetailsToEmailMutationVariables = Exact<{
  offerId: Scalars['String']['input'];
  installments: Scalars['Int']['input'];
}>;

export type SendGeneralTransferDetailsToEmailMutation = {
  __typename?: 'Mutation';
  sendGeneralTransferDetailsToEmail?: boolean | null;
};

export type SendOfferAcceptedMutationVariables = Exact<{
  offerId: Scalars['String']['input'];
}>;

export type SendOfferAcceptedMutation = { __typename?: 'Mutation'; sendOfferAccepted?: boolean | null };

export type SendOffersToEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
  birthDate: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
}>;

export type SendOffersToEmailMutation = { __typename?: 'Mutation'; sendOffersToEmail?: boolean | null };

export type SetInsuranceNumberMutationVariables = Exact<{
  soId: Scalars['String']['input'];
  insuranceNumber: Scalars['String']['input'];
}>;

export type SetInsuranceNumberMutation = { __typename?: 'Mutation'; setInsuranceNumber?: boolean | null };

export type SetCheckoutPaymentAttemptMutationVariables = Exact<{
  offerId: Scalars['String']['input'];
}>;

export type SetCheckoutPaymentAttemptMutation = { __typename?: 'Mutation'; setCheckoutPaymentAttempt?: boolean | null };

export type SetCheckoutPaymentErrorsMutationVariables = Exact<{
  offerId: Scalars['String']['input'];
  errors: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;

export type SetCheckoutPaymentErrorsMutation = { __typename?: 'Mutation'; setCheckoutPaymentErrors?: boolean | null };

export type UpdateCheckoutHealthOfferDataMutationVariables = Exact<{
  params: CheckoutHealthOfferDataInput;
}>;

export type UpdateCheckoutHealthOfferDataMutation = {
  __typename?: 'Mutation';
  updateCheckoutHealthOfferData?: boolean | null;
};

export type GetAdminQueryVariables = Exact<{
  referenceId: Scalars['String']['input'];
  referenceType: Scalars['String']['input'];
  isEncrypted: Scalars['Boolean']['input'];
}>;

export type GetAdminQuery = {
  __typename?: 'Query';
  admin: {
    __typename?: 'AdminRoot';
    assignedAdminByReference?: {
      __typename?: 'PublicAdmin';
      id?: string | null;
      avatar?: string | null;
      name?: string | null;
      email?: string | null;
      phone?: string | null;
      phoneExt?: string | null;
      signature?: string | null;
      emailName?: string | null;
    } | null;
  };
};

export type CheckoutHealthOfferQueryVariables = Exact<{
  offerId: Scalars['String']['input'];
}>;

export type CheckoutHealthOfferQuery = {
  __typename?: 'Query';
  health: {
    __typename?: 'HealthRoot';
    checkoutHealthOffer?: {
      __typename?: 'HealthOffer';
      _id: string;
      publicSoId: string;
      status: string;
      brandId?: string | null;
      publicOfferId: string;
      annotations?: Array<string | null> | null;
      supplementary?: {
        __typename?: 'HealthOfferCalcData';
        label?: string | null;
        actionLabel?: string | null;
        brandName?: string | null;
        brandCode?: string | null;
        numberOfInstallments?: number | null;
        code?: string | null;
        logoUrl?: string | null;
        priceChangeModifier?: {
          __typename?: 'HealthOfferPriceChangeModifier';
          amount?: number | null;
          type?: string | null;
          description?: string | null;
        } | null;
        voucherPriceModifier?: { __typename?: 'VoucherPriceModifier'; amount?: number | null } | null;
        voucherPriceChangeModifier?: {
          __typename?: 'VoucherPriceChangeModifier';
          amount?: number | null;
          type?: string | null;
          description?: string | null;
          code?: string | null;
        } | null;
        visual?: {
          __typename?: 'HealthProductVisual';
          highlight?: boolean | null;
          tooltip?: string | null;
          description?: string | null;
        } | null;
        fixedCoverages?: Array<{
          __typename?: 'HealthOfferCoverage';
          label?: string | null;
          tooltip?: string | null;
          value?: string | null;
          price?: number | null;
          gratis?: { __typename?: 'HealthOfferCoverageGratis'; value?: boolean | null; type?: string | null } | null;
          options?: Array<{
            __typename?: 'HealthOfferCoverageOptions';
            key?: string | null;
            value?: string | null;
          } | null> | null;
        } | null> | null;
        coverages?: Array<{
          __typename?: 'HealthOfferCoverage';
          label?: string | null;
          tooltip?: string | null;
          value?: string | null;
          price?: number | null;
          gratis?: { __typename?: 'HealthOfferCoverageGratis'; value?: boolean | null; type?: string | null } | null;
          options?: Array<{
            __typename?: 'HealthOfferCoverageOptions';
            key?: string | null;
            value?: string | null;
          } | null> | null;
        } | null> | null;
        discounts?: Array<{
          __typename?: 'HealthOfferDiscount';
          value?: string | null;
          tooltip?: string | null;
        } | null> | null;
        paymentSlipInfo?: {
          __typename?: 'PaymentSlipInfo';
          amount?: number | null;
          numOfInstallments?: number | null;
        } | null;
        total?: {
          __typename?: 'HealthOfferTotalPrice';
          generalTransfer?: number | null;
          generalTransferWithInstallments?: number | null;
          creditCard?: number | null;
          creditCardWithInstallments?: number | null;
        } | null;
        includedInPrice?: Array<{ __typename?: 'CoverageForWeb'; label: string; description: string } | null> | null;
        additionalCoverages?: Array<{
          __typename?: 'CoverageForWeb';
          label: string;
          description: string;
        } | null> | null;
      } | null;
      additional?: {
        __typename?: 'HealthOfferCalcData';
        label?: string | null;
        brandName?: string | null;
        brandCode?: string | null;
        numberOfInstallments?: number | null;
        code?: string | null;
        logoUrl?: string | null;
        priceChangeModifier?: {
          __typename?: 'HealthOfferPriceChangeModifier';
          amount?: number | null;
          type?: string | null;
          description?: string | null;
        } | null;
        voucherPriceModifier?: { __typename?: 'VoucherPriceModifier'; amount?: number | null } | null;
        visual?: {
          __typename?: 'HealthProductVisual';
          highlight?: boolean | null;
          tooltip?: string | null;
          description?: string | null;
        } | null;
        coverages?: Array<{
          __typename?: 'HealthOfferCoverage';
          label?: string | null;
          tooltip?: string | null;
          value?: string | null;
          price?: number | null;
          gratis?: { __typename?: 'HealthOfferCoverageGratis'; value?: boolean | null; type?: string | null } | null;
          options?: Array<{
            __typename?: 'HealthOfferCoverageOptions';
            key?: string | null;
            value?: string | null;
          } | null> | null;
        } | null> | null;
        fixedCoverages?: Array<{
          __typename?: 'HealthOfferCoverage';
          label?: string | null;
          tooltip?: string | null;
          value?: string | null;
          price?: number | null;
          gratis?: { __typename?: 'HealthOfferCoverageGratis'; value?: boolean | null; type?: string | null } | null;
          options?: Array<{
            __typename?: 'HealthOfferCoverageOptions';
            key?: string | null;
            value?: string | null;
          } | null> | null;
        } | null> | null;
        discounts?: Array<{
          __typename?: 'HealthOfferDiscount';
          value?: string | null;
          tooltip?: string | null;
        } | null> | null;
        total?: {
          __typename?: 'HealthOfferTotalPrice';
          generalTransfer?: number | null;
          generalTransferWithInstallments?: number | null;
          creditCard?: number | null;
          creditCardWithInstallments?: number | null;
        } | null;
        includedInPrice?: Array<{ __typename?: 'CoverageForWeb'; label: string; description: string } | null> | null;
        additionalCoverages?: Array<{
          __typename?: 'CoverageForWeb';
          label: string;
          description: string;
        } | null> | null;
      } | null;
      total?: {
        __typename?: 'HealthOfferTotalPrice';
        generalTransfer?: number | null;
        generalTransferWithInstallments?: number | null;
        creditCard?: number | null;
        creditCardWithInstallments?: number | null;
      } | null;
    } | null;
    checkoutHealthOfferData?: {
      __typename?: 'HealthOfferData';
      karenca?: boolean | null;
      newPolicyStartDate?: string | null;
      newPolicyStartDateNote?: string | null;
      productCode?: string | null;
      insuredPerson?: {
        __typename?: 'HealthOfferDataInsuredPerson';
        firstName?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
        lastName?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
        birthDate?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
        gender?: { __typename?: 'GenderEditableValue'; value?: GenderEnum | null; isEditable?: boolean | null } | null;
        streetAndHouseNumber?: {
          __typename?: 'StringEditableValue';
          value?: string | null;
          isEditable?: boolean | null;
        } | null;
        street?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
        streetKompareId?: {
          __typename?: 'StringEditableValue';
          value?: string | null;
          isEditable?: boolean | null;
        } | null;
        houseNumber?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
        city?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
        cityKompareId?: {
          __typename?: 'StringEditableValue';
          value?: string | null;
          isEditable?: boolean | null;
        } | null;
        zipCode?: { __typename?: 'IntEditableValue'; value?: number | null; isEditable?: boolean | null } | null;
        oib?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
        insuranceNumber?: {
          __typename?: 'StringEditableValue';
          value?: string | null;
          isEditable?: boolean | null;
        } | null;
        personalIdNumber?: {
          __typename?: 'StringEditableValue';
          value?: string | null;
          isEditable?: boolean | null;
        } | null;
        personalIdIssuer?: {
          __typename?: 'StringEditableValue';
          value?: string | null;
          isEditable?: boolean | null;
        } | null;
        partnerContactEmail?: {
          __typename?: 'StringEditableValue';
          value?: string | null;
          isEditable?: boolean | null;
        } | null;
      } | null;
      contractor?: {
        __typename?: 'HealthOfferDataContractor';
        personType?: PersonTypeEnum | null;
        isSamePerson?: boolean | null;
        person?: {
          __typename?: 'HealthOfferDataContractorPerson';
          firstName?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
          lastName?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
          birthDate?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
          gender?: {
            __typename?: 'GenderEditableValue';
            value?: GenderEnum | null;
            isEditable?: boolean | null;
          } | null;
          streetAndHouseNumber?: {
            __typename?: 'StringEditableValue';
            value?: string | null;
            isEditable?: boolean | null;
          } | null;
          street?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
          houseNumber?: {
            __typename?: 'StringEditableValue';
            value?: string | null;
            isEditable?: boolean | null;
          } | null;
          streetKompareId?: {
            __typename?: 'StringEditableValue';
            value?: string | null;
            isEditable?: boolean | null;
          } | null;
          city?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
          cityKompareId?: {
            __typename?: 'StringEditableValue';
            value?: string | null;
            isEditable?: boolean | null;
          } | null;
          zipCode?: { __typename?: 'IntEditableValue'; value?: number | null; isEditable?: boolean | null } | null;
          oib?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
          partnerContactEmail?: {
            __typename?: 'StringEditableValue';
            value?: string | null;
            isEditable?: boolean | null;
          } | null;
        } | null;
        company?: {
          __typename?: 'HealthOfferDataContractorCompany';
          streetAndHouseNumber?: {
            __typename?: 'StringEditableValue';
            value?: string | null;
            isEditable?: boolean | null;
          } | null;
          street?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
          houseNumber?: {
            __typename?: 'StringEditableValue';
            value?: string | null;
            isEditable?: boolean | null;
          } | null;
          streetKompareId?: {
            __typename?: 'StringEditableValue';
            value?: string | null;
            isEditable?: boolean | null;
          } | null;
          oib?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
          city?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
          cityKompareId?: {
            __typename?: 'StringEditableValue';
            value?: string | null;
            isEditable?: boolean | null;
          } | null;
          companyName?: {
            __typename?: 'StringEditableValue';
            value?: string | null;
            isEditable?: boolean | null;
          } | null;
          zipCode?: { __typename?: 'IntEditableValue'; value?: number | null; isEditable?: boolean | null } | null;
          partnerContactEmail?: {
            __typename?: 'StringEditableValue';
            value?: string | null;
            isEditable?: boolean | null;
          } | null;
        } | null;
      } | null;
      delivery?: {
        __typename?: 'HealthOfferDataDelivery';
        asEntity?: {
          __typename?: 'DeliveryEntityEditableValue';
          value?: DeliveryEntityEnum | null;
          isEditable?: boolean | null;
        } | null;
        name?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
        streetAndHouseNumber?: {
          __typename?: 'StringEditableValue';
          value?: string | null;
          isEditable?: boolean | null;
        } | null;
        street?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
        streetKompareId?: {
          __typename?: 'StringEditableValue';
          value?: string | null;
          isEditable?: boolean | null;
        } | null;
        houseNumber?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
        city?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
        cityKompareId?: {
          __typename?: 'StringEditableValue';
          value?: string | null;
          isEditable?: boolean | null;
        } | null;
        zipCode?: { __typename?: 'IntEditableValue'; value?: number | null; isEditable?: boolean | null } | null;
      } | null;
    } | null;
    checkoutHealthOfferDocuments?: Array<{
      __typename?: 'HealthProductDocuments';
      src?: string | null;
      title?: string | null;
    } | null> | null;
  };
};

export type CheckoutHealthOfferDataQueryVariables = Exact<{
  offerId: Scalars['String']['input'];
}>;

export type CheckoutHealthOfferDataQuery = {
  __typename?: 'Query';
  health: {
    __typename?: 'HealthRoot';
    checkoutHealthOfferData?: {
      __typename?: 'HealthOfferData';
      karenca?: boolean | null;
      newPolicyStartDate?: string | null;
      newPolicyStartDateNote?: string | null;
      productCode?: string | null;
      insuredPerson?: {
        __typename?: 'HealthOfferDataInsuredPerson';
        firstName?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
        lastName?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
        birthDate?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
        gender?: { __typename?: 'GenderEditableValue'; value?: GenderEnum | null; isEditable?: boolean | null } | null;
        streetAndHouseNumber?: {
          __typename?: 'StringEditableValue';
          value?: string | null;
          isEditable?: boolean | null;
        } | null;
        street?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
        streetKompareId?: {
          __typename?: 'StringEditableValue';
          value?: string | null;
          isEditable?: boolean | null;
        } | null;
        houseNumber?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
        city?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
        cityKompareId?: {
          __typename?: 'StringEditableValue';
          value?: string | null;
          isEditable?: boolean | null;
        } | null;
        zipCode?: { __typename?: 'IntEditableValue'; value?: number | null; isEditable?: boolean | null } | null;
        oib?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
        personalIdNumber?: {
          __typename?: 'StringEditableValue';
          value?: string | null;
          isEditable?: boolean | null;
        } | null;
        personalIdIssuer?: {
          __typename?: 'StringEditableValue';
          value?: string | null;
          isEditable?: boolean | null;
        } | null;
        partnerContactEmail?: {
          __typename?: 'StringEditableValue';
          value?: string | null;
          isEditable?: boolean | null;
        } | null;
      } | null;
      contractor?: {
        __typename?: 'HealthOfferDataContractor';
        personType?: PersonTypeEnum | null;
        isSamePerson?: boolean | null;
        person?: {
          __typename?: 'HealthOfferDataContractorPerson';
          firstName?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
          lastName?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
          birthDate?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
          gender?: {
            __typename?: 'GenderEditableValue';
            value?: GenderEnum | null;
            isEditable?: boolean | null;
          } | null;
          streetAndHouseNumber?: {
            __typename?: 'StringEditableValue';
            value?: string | null;
            isEditable?: boolean | null;
          } | null;
          street?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
          houseNumber?: {
            __typename?: 'StringEditableValue';
            value?: string | null;
            isEditable?: boolean | null;
          } | null;
          streetKompareId?: {
            __typename?: 'StringEditableValue';
            value?: string | null;
            isEditable?: boolean | null;
          } | null;
          city?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
          cityKompareId?: {
            __typename?: 'StringEditableValue';
            value?: string | null;
            isEditable?: boolean | null;
          } | null;
          zipCode?: { __typename?: 'IntEditableValue'; value?: number | null; isEditable?: boolean | null } | null;
          oib?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
          partnerContactEmail?: {
            __typename?: 'StringEditableValue';
            value?: string | null;
            isEditable?: boolean | null;
          } | null;
        } | null;
        company?: {
          __typename?: 'HealthOfferDataContractorCompany';
          streetAndHouseNumber?: {
            __typename?: 'StringEditableValue';
            value?: string | null;
            isEditable?: boolean | null;
          } | null;
          street?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
          houseNumber?: {
            __typename?: 'StringEditableValue';
            value?: string | null;
            isEditable?: boolean | null;
          } | null;
          streetKompareId?: {
            __typename?: 'StringEditableValue';
            value?: string | null;
            isEditable?: boolean | null;
          } | null;
          oib?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
          city?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
          cityKompareId?: {
            __typename?: 'StringEditableValue';
            value?: string | null;
            isEditable?: boolean | null;
          } | null;
          companyName?: {
            __typename?: 'StringEditableValue';
            value?: string | null;
            isEditable?: boolean | null;
          } | null;
          zipCode?: { __typename?: 'IntEditableValue'; value?: number | null; isEditable?: boolean | null } | null;
          partnerContactEmail?: {
            __typename?: 'StringEditableValue';
            value?: string | null;
            isEditable?: boolean | null;
          } | null;
        } | null;
      } | null;
      delivery?: {
        __typename?: 'HealthOfferDataDelivery';
        asEntity?: {
          __typename?: 'DeliveryEntityEditableValue';
          value?: DeliveryEntityEnum | null;
          isEditable?: boolean | null;
        } | null;
        name?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
        streetAndHouseNumber?: {
          __typename?: 'StringEditableValue';
          value?: string | null;
          isEditable?: boolean | null;
        } | null;
        street?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
        streetKompareId?: {
          __typename?: 'StringEditableValue';
          value?: string | null;
          isEditable?: boolean | null;
        } | null;
        houseNumber?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
        city?: { __typename?: 'StringEditableValue'; value?: string | null; isEditable?: boolean | null } | null;
        cityKompareId?: {
          __typename?: 'StringEditableValue';
          value?: string | null;
          isEditable?: boolean | null;
        } | null;
        zipCode?: { __typename?: 'IntEditableValue'; value?: number | null; isEditable?: boolean | null } | null;
      } | null;
    } | null;
  };
};

export type CheckoutHealthOfferGeneralTransferDetailsQueryVariables = Exact<{
  offerId: Scalars['String']['input'];
  installments: Scalars['Int']['input'];
}>;

export type CheckoutHealthOfferGeneralTransferDetailsQuery = {
  __typename?: 'Query';
  health: {
    __typename?: 'HealthRoot';
    checkoutHealthOfferGeneralTransferDetails?: {
      __typename?: 'HealthOfferGeneralTransferDetails';
      price?: number | null;
      customerFirstName?: string | null;
      customerLastName?: string | null;
      customerAddress?: string | null;
      customerCity?: string | null;
      customerZipCode?: string | null;
      customerCountry?: string | null;
      customerPhone?: string | null;
      customerEmail?: string | null;
      customerOib?: string | null;
      recipientAccountNumber?: string | null;
      recipientAddress?: string | null;
      recipientCity?: string | null;
      recipientZipCode?: string | null;
      recipientName?: string | null;
      referenceNumberType?: string | null;
      referenceNumber?: string | null;
      referencePrefix?: string | null;
      referenceSuffix?: string | null;
      model?: string | null;
      description?: string | null;
      numberOfInstallments?: number | null;
    } | null;
  };
};

export type CheckoutHealthOfferPaymentOptionsQueryVariables = Exact<{
  offerId: Scalars['String']['input'];
}>;

export type CheckoutHealthOfferPaymentOptionsQuery = {
  __typename?: 'Query';
  health: {
    __typename?: 'HealthRoot';
    checkoutHealthOfferPaymentOptions?: {
      __typename?: 'HealthOfferPaymentOptionResponse';
      offer?: {
        __typename?: 'HealthOffer';
        status: string;
        brandId?: string | null;
        supplementary?: {
          __typename?: 'HealthOfferCalcData';
          label?: string | null;
          brandName?: string | null;
          brandCode?: string | null;
          code?: string | null;
          actionLabel?: string | null;
          total?: {
            __typename?: 'HealthOfferTotalPrice';
            generalTransfer?: number | null;
            generalTransferWithInstallments?: number | null;
            creditCard?: number | null;
            creditCardWithInstallments?: number | null;
          } | null;
        } | null;
        additional?: {
          __typename?: 'HealthOfferCalcData';
          label?: string | null;
          brandName?: string | null;
          brandCode?: string | null;
          code?: string | null;
          total?: {
            __typename?: 'HealthOfferTotalPrice';
            generalTransfer?: number | null;
            generalTransferWithInstallments?: number | null;
            creditCard?: number | null;
            creditCardWithInstallments?: number | null;
          } | null;
        } | null;
      } | null;
      paymentOptions?: Array<{
        __typename?: 'HealthOfferPaymentOption';
        paymentOption: string;
        paymentTypes?: Array<{
          __typename?: 'HealthOfferPaymentType';
          paymentType: string;
          paymentTypeLabel?: string | null;
          installments?: Array<{
            __typename?: 'HealthOfferPaymentInstallment';
            installment: number;
            amount: number;
            paymentTypeDiscount?: number | null;
          } | null> | null;
        } | null> | null;
        paymentSlipInfo?: {
          __typename?: 'PaymentSlipInfo';
          amount?: number | null;
          numOfInstallments?: number | null;
        } | null;
      } | null> | null;
    } | null;
    checkoutHealthOfferGeneralTransferDetailsOneTime?: {
      __typename?: 'HealthOfferGeneralTransferDetails';
      price?: number | null;
      customerFirstName?: string | null;
      customerLastName?: string | null;
      customerAddress?: string | null;
      customerCity?: string | null;
      customerZipCode?: string | null;
      customerCountry?: string | null;
      customerPhone?: string | null;
      customerEmail?: string | null;
      customerOib?: string | null;
      recipientAccountNumber?: string | null;
      recipientAddress?: string | null;
      recipientCity?: string | null;
      recipientZipCode?: string | null;
      recipientName?: string | null;
      referenceNumber?: string | null;
      referenceNumberType?: string | null;
      referencePrefix?: string | null;
      referenceSuffix?: string | null;
      model?: string | null;
      description?: string | null;
      numberOfInstallments?: number | null;
    } | null;
    checkoutHealthOfferGeneralTransferDetailsInstallments?: {
      __typename?: 'HealthOfferGeneralTransferDetails';
      price?: number | null;
      customerFirstName?: string | null;
      customerLastName?: string | null;
      customerAddress?: string | null;
      customerCity?: string | null;
      customerZipCode?: string | null;
      customerCountry?: string | null;
      customerPhone?: string | null;
      customerEmail?: string | null;
      customerOib?: string | null;
      recipientAccountNumber?: string | null;
      recipientAddress?: string | null;
      recipientCity?: string | null;
      recipientZipCode?: string | null;
      recipientName?: string | null;
      referenceNumber?: string | null;
      referenceNumberType?: string | null;
      referencePrefix?: string | null;
      referenceSuffix?: string | null;
      model?: string | null;
      description?: string | null;
      numberOfInstallments?: number | null;
    } | null;
    checkoutHealthOffer?: {
      __typename?: 'HealthOffer';
      _id: string;
      publicSoId: string;
      status: string;
      brandId?: string | null;
      publicOfferId: string;
      annotations?: Array<string | null> | null;
      supplementary?: {
        __typename?: 'HealthOfferCalcData';
        label?: string | null;
        actionLabel?: string | null;
        brandName?: string | null;
        brandCode?: string | null;
        numberOfInstallments?: number | null;
        code?: string | null;
        logoUrl?: string | null;
        priceChangeModifier?: {
          __typename?: 'HealthOfferPriceChangeModifier';
          amount?: number | null;
          type?: string | null;
          description?: string | null;
        } | null;
        voucherPriceModifier?: { __typename?: 'VoucherPriceModifier'; amount?: number | null } | null;
        voucherPriceChangeModifier?: {
          __typename?: 'VoucherPriceChangeModifier';
          amount?: number | null;
          type?: string | null;
          description?: string | null;
          code?: string | null;
        } | null;
        visual?: {
          __typename?: 'HealthProductVisual';
          highlight?: boolean | null;
          tooltip?: string | null;
          description?: string | null;
        } | null;
        fixedCoverages?: Array<{
          __typename?: 'HealthOfferCoverage';
          label?: string | null;
          tooltip?: string | null;
          value?: string | null;
          price?: number | null;
          gratis?: { __typename?: 'HealthOfferCoverageGratis'; value?: boolean | null; type?: string | null } | null;
          options?: Array<{
            __typename?: 'HealthOfferCoverageOptions';
            key?: string | null;
            value?: string | null;
          } | null> | null;
        } | null> | null;
        coverages?: Array<{
          __typename?: 'HealthOfferCoverage';
          label?: string | null;
          tooltip?: string | null;
          value?: string | null;
          price?: number | null;
          gratis?: { __typename?: 'HealthOfferCoverageGratis'; value?: boolean | null; type?: string | null } | null;
          options?: Array<{
            __typename?: 'HealthOfferCoverageOptions';
            key?: string | null;
            value?: string | null;
          } | null> | null;
        } | null> | null;
        discounts?: Array<{
          __typename?: 'HealthOfferDiscount';
          value?: string | null;
          tooltip?: string | null;
        } | null> | null;
        paymentSlipInfo?: {
          __typename?: 'PaymentSlipInfo';
          amount?: number | null;
          numOfInstallments?: number | null;
        } | null;
        total?: {
          __typename?: 'HealthOfferTotalPrice';
          generalTransfer?: number | null;
          generalTransferWithInstallments?: number | null;
          creditCard?: number | null;
          creditCardWithInstallments?: number | null;
        } | null;
      } | null;
      additional?: {
        __typename?: 'HealthOfferCalcData';
        label?: string | null;
        brandName?: string | null;
        brandCode?: string | null;
        numberOfInstallments?: number | null;
        code?: string | null;
        logoUrl?: string | null;
        priceChangeModifier?: {
          __typename?: 'HealthOfferPriceChangeModifier';
          amount?: number | null;
          type?: string | null;
          description?: string | null;
        } | null;
        voucherPriceModifier?: { __typename?: 'VoucherPriceModifier'; amount?: number | null } | null;
        visual?: {
          __typename?: 'HealthProductVisual';
          highlight?: boolean | null;
          tooltip?: string | null;
          description?: string | null;
        } | null;
        coverages?: Array<{
          __typename?: 'HealthOfferCoverage';
          label?: string | null;
          tooltip?: string | null;
          value?: string | null;
          price?: number | null;
          gratis?: { __typename?: 'HealthOfferCoverageGratis'; value?: boolean | null; type?: string | null } | null;
          options?: Array<{
            __typename?: 'HealthOfferCoverageOptions';
            key?: string | null;
            value?: string | null;
          } | null> | null;
        } | null> | null;
        fixedCoverages?: Array<{
          __typename?: 'HealthOfferCoverage';
          label?: string | null;
          tooltip?: string | null;
          value?: string | null;
          price?: number | null;
          gratis?: { __typename?: 'HealthOfferCoverageGratis'; value?: boolean | null; type?: string | null } | null;
          options?: Array<{
            __typename?: 'HealthOfferCoverageOptions';
            key?: string | null;
            value?: string | null;
          } | null> | null;
        } | null> | null;
        discounts?: Array<{
          __typename?: 'HealthOfferDiscount';
          value?: string | null;
          tooltip?: string | null;
        } | null> | null;
        total?: {
          __typename?: 'HealthOfferTotalPrice';
          generalTransfer?: number | null;
          generalTransferWithInstallments?: number | null;
          creditCard?: number | null;
          creditCardWithInstallments?: number | null;
        } | null;
      } | null;
      total?: {
        __typename?: 'HealthOfferTotalPrice';
        generalTransfer?: number | null;
        generalTransferWithInstallments?: number | null;
        creditCard?: number | null;
        creditCardWithInstallments?: number | null;
      } | null;
    } | null;
  };
};

export type WsPayPaymentDetailsQueryVariables = Exact<{
  offerId: Scalars['String']['input'];
  paymentOption: HealthOfferPaymentOptionEnum;
  paymentType: Scalars['String']['input'];
  installments: Scalars['Int']['input'];
}>;

export type WsPayPaymentDetailsQuery = {
  __typename?: 'Query';
  health: {
    __typename?: 'HealthRoot';
    checkoutHealthOfferWSPayPaymentDetails?: {
      __typename?: 'HealthOfferWSPayDetails';
      ShopID?: string | null;
      ShoppingCartID?: string | null;
      TotalAmount?: string | null;
      Signature?: string | null;
      ReturnURL?: string | null;
      CancelURL?: string | null;
      ReturnErrorURL?: string | null;
      PaymentPlan?: string | null;
      CustomerFirstName?: string | null;
      CustomerLastName?: string | null;
      CustomerAddress?: string | null;
      CustomerCity?: string | null;
      CustomerZIP?: string | null;
      CustomerCountry?: string | null;
      CustomerPhone?: string | null;
      CustomerEmail?: string | null;
      PaymentMethod?: string | null;
      Iframe?: string | null;
      IframeResponseTarget?: string | null;
    } | null;
  };
};

export type CheckoutHealthOffersQueryVariables = Exact<{
  soId: Scalars['String']['input'];
}>;

export type CheckoutHealthOffersQuery = {
  __typename?: 'Query';
  health: {
    __typename?: 'HealthRoot';
    checkoutHealthOffers?: Array<{
      __typename?: 'HealthOffer';
      _id: string;
      publicSoId: string;
      publicOfferId: string;
      brandId?: string | null;
      status: string;
      paidAt?: string | null;
      isPublished: boolean;
      annotations?: Array<string | null> | null;
      termsAcceptedAt?: string | null;
      iddTermsAcceptedAt?: string | null;
      allianzGDPRAcceptedAt?: string | null;
      acceptedEmailDocumentationDeliveryAt?: string | null;
      supplementary?: {
        __typename?: 'HealthOfferCalcData';
        label?: string | null;
        code?: string | null;
        brandName?: string | null;
        brandCode?: string | null;
        logoUrl?: string | null;
        numberOfInstallments?: number | null;
        baseProductPrice?: number | null;
        actionLabel?: string | null;
        includedInPrice?: Array<{ __typename?: 'CoverageForWeb'; label: string; description: string } | null> | null;
        additionalCoverages?: Array<{
          __typename?: 'CoverageForWeb';
          label: string;
          description: string;
        } | null> | null;
      } | null;
      additional?: {
        __typename?: 'HealthOfferCalcData';
        label?: string | null;
        code?: string | null;
        brandName?: string | null;
        brandCode?: string | null;
        logoUrl?: string | null;
        numberOfInstallments?: number | null;
        baseProductPrice?: number | null;
      } | null;
      total?: {
        __typename?: 'HealthOfferTotalPrice';
        generalTransfer?: number | null;
        generalTransferWithInstallments?: number | null;
        creditCard?: number | null;
        creditCardWithInstallments?: number | null;
      } | null;
    } | null> | null;
  };
};

export type HealthQueryVariables = Exact<{
  birthDate: Scalars['String']['input'];
}>;

export type HealthQuery = {
  __typename?: 'Query';
  health: {
    __typename?: 'HealthRoot';
    webCalculationsSupplementary?: Array<{
      __typename?: 'WebCalculationForProduct';
      productCode: string;
      productLabel: string;
      brandName: string;
      actionLabel?: string | null;
      logo: string;
      price: { __typename?: 'CalculationPrice'; totalOneTimePayment: number; totalWithInstallments: number };
      includedInPrice: Array<{ __typename?: 'CoverageForWeb'; label: string; description: string } | null>;
      additionalCoverages: Array<{ __typename?: 'CoverageForWeb'; label: string; description: string } | null>;
    } | null> | null;
  };
};

export const CallMeDocument = gql`
  mutation callMe($callMeInput: CallMeInput!) {
    callMe(callMeInput: $callMeInput)
  }
`;
export type CallMeMutationFn = Apollo.MutationFunction<CallMeMutation, CallMeMutationVariables>;

/**
 * __useCallMeMutation__
 *
 * To run a mutation, you first call `useCallMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCallMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [callMeMutation, { data, loading, error }] = useCallMeMutation({
 *   variables: {
 *      callMeInput: // value for 'callMeInput'
 *   },
 * });
 */
export function useCallMeMutation(baseOptions?: Apollo.MutationHookOptions<CallMeMutation, CallMeMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CallMeMutation, CallMeMutationVariables>(CallMeDocument, options);
}
export type CallMeMutationHookResult = ReturnType<typeof useCallMeMutation>;
export type CallMeMutationResult = Apollo.MutationResult<CallMeMutation>;
export type CallMeMutationOptions = Apollo.BaseMutationOptions<CallMeMutation, CallMeMutationVariables>;
export const CheckAndApplyVoucherCodeDocument = gql`
  mutation checkAndApplyVoucherCode($voucherCode: String!, $offerId: String!) {
    checkAndApplyVoucherCode(voucherCode: $voucherCode, offerId: $offerId) {
      _id
      publicSoId
      status
      brandId
      publicOfferId
      supplementary {
        label
        brandName
        brandCode
        priceChangeModifier {
          amount
          type
          description
        }
        voucherPriceModifier {
          amount
        }
        voucherPriceChangeModifier {
          amount
          type
          description
          code
        }
        numberOfInstallments
        code
        visual {
          highlight
          tooltip
          description
        }
        logoUrl
        fixedCoverages {
          label
          tooltip
          value
          price
          gratis {
            value
            type
          }
          options {
            key
            value
          }
        }
        coverages {
          label
          tooltip
          value
          price
          gratis {
            value
            type
          }
          options {
            key
            value
          }
        }
        discounts {
          value
          tooltip
        }
        paymentSlipInfo {
          amount
          numOfInstallments
        }
        total {
          generalTransfer
          generalTransferWithInstallments
          creditCard
          creditCardWithInstallments
        }
        includedInPrice {
          label
          description
        }
        additionalCoverages {
          label
          description
        }
      }
      additional {
        label
        brandName
        brandCode
        priceChangeModifier {
          amount
          type
          description
        }
        voucherPriceModifier {
          amount
        }
        numberOfInstallments
        code
        visual {
          highlight
          tooltip
          description
        }
        logoUrl
        coverages {
          label
          tooltip
          value
          price
          gratis {
            value
            type
          }
          options {
            key
            value
          }
        }
        fixedCoverages {
          label
          tooltip
          value
          price
          gratis {
            value
            type
          }
          options {
            key
            value
          }
        }
        discounts {
          value
          tooltip
        }
        total {
          generalTransfer
          generalTransferWithInstallments
          creditCard
          creditCardWithInstallments
        }
        includedInPrice {
          label
          description
        }
        additionalCoverages {
          label
          description
        }
      }
      total {
        generalTransfer
        generalTransferWithInstallments
        creditCard
        creditCardWithInstallments
      }
      annotations
    }
  }
`;
export type CheckAndApplyVoucherCodeMutationFn = Apollo.MutationFunction<
  CheckAndApplyVoucherCodeMutation,
  CheckAndApplyVoucherCodeMutationVariables
>;

/**
 * __useCheckAndApplyVoucherCodeMutation__
 *
 * To run a mutation, you first call `useCheckAndApplyVoucherCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckAndApplyVoucherCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkAndApplyVoucherCodeMutation, { data, loading, error }] = useCheckAndApplyVoucherCodeMutation({
 *   variables: {
 *      voucherCode: // value for 'voucherCode'
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useCheckAndApplyVoucherCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<CheckAndApplyVoucherCodeMutation, CheckAndApplyVoucherCodeMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CheckAndApplyVoucherCodeMutation, CheckAndApplyVoucherCodeMutationVariables>(
    CheckAndApplyVoucherCodeDocument,
    options
  );
}
export type CheckAndApplyVoucherCodeMutationHookResult = ReturnType<typeof useCheckAndApplyVoucherCodeMutation>;
export type CheckAndApplyVoucherCodeMutationResult = Apollo.MutationResult<CheckAndApplyVoucherCodeMutation>;
export type CheckAndApplyVoucherCodeMutationOptions = Apollo.BaseMutationOptions<
  CheckAndApplyVoucherCodeMutation,
  CheckAndApplyVoucherCodeMutationVariables
>;
export const ConfirmCheckoutWsPaySignatureDocument = gql`
  mutation confirmCheckoutWSPaySignature($params: ConfirmCheckoutWSPaySignatureInput!) {
    confirmCheckoutWSPaySignature(params: $params) {
      success
      alreadyPaid
    }
  }
`;
export type ConfirmCheckoutWsPaySignatureMutationFn = Apollo.MutationFunction<
  ConfirmCheckoutWsPaySignatureMutation,
  ConfirmCheckoutWsPaySignatureMutationVariables
>;

/**
 * __useConfirmCheckoutWsPaySignatureMutation__
 *
 * To run a mutation, you first call `useConfirmCheckoutWsPaySignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmCheckoutWsPaySignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmCheckoutWsPaySignatureMutation, { data, loading, error }] = useConfirmCheckoutWsPaySignatureMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useConfirmCheckoutWsPaySignatureMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfirmCheckoutWsPaySignatureMutation,
    ConfirmCheckoutWsPaySignatureMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ConfirmCheckoutWsPaySignatureMutation, ConfirmCheckoutWsPaySignatureMutationVariables>(
    ConfirmCheckoutWsPaySignatureDocument,
    options
  );
}
export type ConfirmCheckoutWsPaySignatureMutationHookResult = ReturnType<
  typeof useConfirmCheckoutWsPaySignatureMutation
>;
export type ConfirmCheckoutWsPaySignatureMutationResult = Apollo.MutationResult<ConfirmCheckoutWsPaySignatureMutation>;
export type ConfirmCheckoutWsPaySignatureMutationOptions = Apollo.BaseMutationOptions<
  ConfirmCheckoutWsPaySignatureMutation,
  ConfirmCheckoutWsPaySignatureMutationVariables
>;
export const CreateCheckoutHealthSoDocument = gql`
  mutation createCheckoutHealthSO(
    $birthDate: String!
    $email: String!
    $productTypeCode: String!
    $phoneNumber: String!
    $source: String
    $consents: [HealthConsent]
  ) {
    createCheckoutHealthSO(
      birthDate: $birthDate
      email: $email
      productTypeCode: $productTypeCode
      phoneNumber: $phoneNumber
      source: $source
      consents: $consents
    )
  }
`;
export type CreateCheckoutHealthSoMutationFn = Apollo.MutationFunction<
  CreateCheckoutHealthSoMutation,
  CreateCheckoutHealthSoMutationVariables
>;

/**
 * __useCreateCheckoutHealthSoMutation__
 *
 * To run a mutation, you first call `useCreateCheckoutHealthSoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutHealthSoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckoutHealthSoMutation, { data, loading, error }] = useCreateCheckoutHealthSoMutation({
 *   variables: {
 *      birthDate: // value for 'birthDate'
 *      email: // value for 'email'
 *      productTypeCode: // value for 'productTypeCode'
 *      phoneNumber: // value for 'phoneNumber'
 *      source: // value for 'source'
 *      consents: // value for 'consents'
 *   },
 * });
 */
export function useCreateCheckoutHealthSoMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCheckoutHealthSoMutation, CreateCheckoutHealthSoMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCheckoutHealthSoMutation, CreateCheckoutHealthSoMutationVariables>(
    CreateCheckoutHealthSoDocument,
    options
  );
}
export type CreateCheckoutHealthSoMutationHookResult = ReturnType<typeof useCreateCheckoutHealthSoMutation>;
export type CreateCheckoutHealthSoMutationResult = Apollo.MutationResult<CreateCheckoutHealthSoMutation>;
export type CreateCheckoutHealthSoMutationOptions = Apollo.BaseMutationOptions<
  CreateCheckoutHealthSoMutation,
  CreateCheckoutHealthSoMutationVariables
>;
export const CreateCheckoutHealthOfferDocument = gql`
  mutation createCheckoutHealthOffer(
    $soId: String
    $birthDate: String!
    $email: String!
    $phoneNumber: String!
    $source: String
    $productTypeCode: String!
    $productCode: String!
    $coverages: [String!]
  ) {
    createCheckoutHealthOffer(
      soId: $soId
      birthDate: $birthDate
      email: $email
      phoneNumber: $phoneNumber
      source: $source
      productTypeCode: $productTypeCode
      productCode: $productCode
      coverages: $coverages
    )
  }
`;
export type CreateCheckoutHealthOfferMutationFn = Apollo.MutationFunction<
  CreateCheckoutHealthOfferMutation,
  CreateCheckoutHealthOfferMutationVariables
>;

/**
 * __useCreateCheckoutHealthOfferMutation__
 *
 * To run a mutation, you first call `useCreateCheckoutHealthOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutHealthOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckoutHealthOfferMutation, { data, loading, error }] = useCreateCheckoutHealthOfferMutation({
 *   variables: {
 *      soId: // value for 'soId'
 *      birthDate: // value for 'birthDate'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *      source: // value for 'source'
 *      productTypeCode: // value for 'productTypeCode'
 *      productCode: // value for 'productCode'
 *      coverages: // value for 'coverages'
 *   },
 * });
 */
export function useCreateCheckoutHealthOfferMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCheckoutHealthOfferMutation,
    CreateCheckoutHealthOfferMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCheckoutHealthOfferMutation, CreateCheckoutHealthOfferMutationVariables>(
    CreateCheckoutHealthOfferDocument,
    options
  );
}
export type CreateCheckoutHealthOfferMutationHookResult = ReturnType<typeof useCreateCheckoutHealthOfferMutation>;
export type CreateCheckoutHealthOfferMutationResult = Apollo.MutationResult<CreateCheckoutHealthOfferMutation>;
export type CreateCheckoutHealthOfferMutationOptions = Apollo.BaseMutationOptions<
  CreateCheckoutHealthOfferMutation,
  CreateCheckoutHealthOfferMutationVariables
>;
export const RemoveVoucherCodeDocument = gql`
  mutation removeVoucherCode($offerId: String!) {
    removeVoucherCode(offerId: $offerId) {
      _id
      publicSoId
      status
      brandId
      publicOfferId
      supplementary {
        label
        brandName
        brandCode
        priceChangeModifier {
          amount
          type
          description
        }
        voucherPriceModifier {
          amount
        }
        voucherPriceChangeModifier {
          amount
          type
          description
          code
        }
        numberOfInstallments
        code
        visual {
          highlight
          tooltip
          description
        }
        logoUrl
        fixedCoverages {
          label
          tooltip
          value
          price
          gratis {
            value
            type
          }
          options {
            key
            value
          }
        }
        coverages {
          label
          tooltip
          value
          price
          gratis {
            value
            type
          }
          options {
            key
            value
          }
        }
        discounts {
          value
          tooltip
        }
        paymentSlipInfo {
          amount
          numOfInstallments
        }
        total {
          generalTransfer
          generalTransferWithInstallments
          creditCard
          creditCardWithInstallments
        }
        includedInPrice {
          label
          description
        }
        additionalCoverages {
          label
          description
        }
      }
      additional {
        label
        brandName
        brandCode
        priceChangeModifier {
          amount
          type
          description
        }
        voucherPriceModifier {
          amount
        }
        numberOfInstallments
        code
        visual {
          highlight
          tooltip
          description
        }
        logoUrl
        coverages {
          label
          tooltip
          value
          price
          gratis {
            value
            type
          }
          options {
            key
            value
          }
        }
        fixedCoverages {
          label
          tooltip
          value
          price
          gratis {
            value
            type
          }
          options {
            key
            value
          }
        }
        discounts {
          value
          tooltip
        }
        total {
          generalTransfer
          generalTransferWithInstallments
          creditCard
          creditCardWithInstallments
        }
        includedInPrice {
          label
          description
        }
        additionalCoverages {
          label
          description
        }
      }
      total {
        generalTransfer
        generalTransferWithInstallments
        creditCard
        creditCardWithInstallments
      }
      annotations
    }
  }
`;
export type RemoveVoucherCodeMutationFn = Apollo.MutationFunction<
  RemoveVoucherCodeMutation,
  RemoveVoucherCodeMutationVariables
>;

/**
 * __useRemoveVoucherCodeMutation__
 *
 * To run a mutation, you first call `useRemoveVoucherCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveVoucherCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeVoucherCodeMutation, { data, loading, error }] = useRemoveVoucherCodeMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useRemoveVoucherCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<RemoveVoucherCodeMutation, RemoveVoucherCodeMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveVoucherCodeMutation, RemoveVoucherCodeMutationVariables>(
    RemoveVoucherCodeDocument,
    options
  );
}
export type RemoveVoucherCodeMutationHookResult = ReturnType<typeof useRemoveVoucherCodeMutation>;
export type RemoveVoucherCodeMutationResult = Apollo.MutationResult<RemoveVoucherCodeMutation>;
export type RemoveVoucherCodeMutationOptions = Apollo.BaseMutationOptions<
  RemoveVoucherCodeMutation,
  RemoveVoucherCodeMutationVariables
>;
export const SaveConsentDocument = gql`
  mutation saveConsent($params: ConsentInput!) {
    saveConsent(params: $params)
  }
`;
export type SaveConsentMutationFn = Apollo.MutationFunction<SaveConsentMutation, SaveConsentMutationVariables>;

/**
 * __useSaveConsentMutation__
 *
 * To run a mutation, you first call `useSaveConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveConsentMutation, { data, loading, error }] = useSaveConsentMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useSaveConsentMutation(
  baseOptions?: Apollo.MutationHookOptions<SaveConsentMutation, SaveConsentMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SaveConsentMutation, SaveConsentMutationVariables>(SaveConsentDocument, options);
}
export type SaveConsentMutationHookResult = ReturnType<typeof useSaveConsentMutation>;
export type SaveConsentMutationResult = Apollo.MutationResult<SaveConsentMutation>;
export type SaveConsentMutationOptions = Apollo.BaseMutationOptions<SaveConsentMutation, SaveConsentMutationVariables>;
export const SendGeneralTransferDetailsToEmailDocument = gql`
  mutation sendGeneralTransferDetailsToEmail($offerId: String!, $installments: Int!) {
    sendGeneralTransferDetailsToEmail(offerId: $offerId, installments: $installments)
  }
`;
export type SendGeneralTransferDetailsToEmailMutationFn = Apollo.MutationFunction<
  SendGeneralTransferDetailsToEmailMutation,
  SendGeneralTransferDetailsToEmailMutationVariables
>;

/**
 * __useSendGeneralTransferDetailsToEmailMutation__
 *
 * To run a mutation, you first call `useSendGeneralTransferDetailsToEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendGeneralTransferDetailsToEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendGeneralTransferDetailsToEmailMutation, { data, loading, error }] = useSendGeneralTransferDetailsToEmailMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *      installments: // value for 'installments'
 *   },
 * });
 */
export function useSendGeneralTransferDetailsToEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendGeneralTransferDetailsToEmailMutation,
    SendGeneralTransferDetailsToEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendGeneralTransferDetailsToEmailMutation,
    SendGeneralTransferDetailsToEmailMutationVariables
  >(SendGeneralTransferDetailsToEmailDocument, options);
}
export type SendGeneralTransferDetailsToEmailMutationHookResult = ReturnType<
  typeof useSendGeneralTransferDetailsToEmailMutation
>;
export type SendGeneralTransferDetailsToEmailMutationResult =
  Apollo.MutationResult<SendGeneralTransferDetailsToEmailMutation>;
export type SendGeneralTransferDetailsToEmailMutationOptions = Apollo.BaseMutationOptions<
  SendGeneralTransferDetailsToEmailMutation,
  SendGeneralTransferDetailsToEmailMutationVariables
>;
export const SendOfferAcceptedDocument = gql`
  mutation sendOfferAccepted($offerId: String!) {
    sendOfferAccepted(offerId: $offerId)
  }
`;
export type SendOfferAcceptedMutationFn = Apollo.MutationFunction<
  SendOfferAcceptedMutation,
  SendOfferAcceptedMutationVariables
>;

/**
 * __useSendOfferAcceptedMutation__
 *
 * To run a mutation, you first call `useSendOfferAcceptedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOfferAcceptedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOfferAcceptedMutation, { data, loading, error }] = useSendOfferAcceptedMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useSendOfferAcceptedMutation(
  baseOptions?: Apollo.MutationHookOptions<SendOfferAcceptedMutation, SendOfferAcceptedMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SendOfferAcceptedMutation, SendOfferAcceptedMutationVariables>(
    SendOfferAcceptedDocument,
    options
  );
}
export type SendOfferAcceptedMutationHookResult = ReturnType<typeof useSendOfferAcceptedMutation>;
export type SendOfferAcceptedMutationResult = Apollo.MutationResult<SendOfferAcceptedMutation>;
export type SendOfferAcceptedMutationOptions = Apollo.BaseMutationOptions<
  SendOfferAcceptedMutation,
  SendOfferAcceptedMutationVariables
>;
export const SendOffersToEmailDocument = gql`
  mutation sendOffersToEmail($email: String!, $birthDate: String!, $phoneNumber: String!) {
    sendOffersToEmail(email: $email, birthDate: $birthDate, phoneNumber: $phoneNumber)
  }
`;
export type SendOffersToEmailMutationFn = Apollo.MutationFunction<
  SendOffersToEmailMutation,
  SendOffersToEmailMutationVariables
>;

/**
 * __useSendOffersToEmailMutation__
 *
 * To run a mutation, you first call `useSendOffersToEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOffersToEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOffersToEmailMutation, { data, loading, error }] = useSendOffersToEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *      birthDate: // value for 'birthDate'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useSendOffersToEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<SendOffersToEmailMutation, SendOffersToEmailMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SendOffersToEmailMutation, SendOffersToEmailMutationVariables>(
    SendOffersToEmailDocument,
    options
  );
}
export type SendOffersToEmailMutationHookResult = ReturnType<typeof useSendOffersToEmailMutation>;
export type SendOffersToEmailMutationResult = Apollo.MutationResult<SendOffersToEmailMutation>;
export type SendOffersToEmailMutationOptions = Apollo.BaseMutationOptions<
  SendOffersToEmailMutation,
  SendOffersToEmailMutationVariables
>;
export const SetInsuranceNumberDocument = gql`
  mutation setInsuranceNumber($soId: String!, $insuranceNumber: String!) {
    setInsuranceNumber(soId: $soId, insuranceNumber: $insuranceNumber)
  }
`;
export type SetInsuranceNumberMutationFn = Apollo.MutationFunction<
  SetInsuranceNumberMutation,
  SetInsuranceNumberMutationVariables
>;

/**
 * __useSetInsuranceNumberMutation__
 *
 * To run a mutation, you first call `useSetInsuranceNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetInsuranceNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setInsuranceNumberMutation, { data, loading, error }] = useSetInsuranceNumberMutation({
 *   variables: {
 *      soId: // value for 'soId'
 *      insuranceNumber: // value for 'insuranceNumber'
 *   },
 * });
 */
export function useSetInsuranceNumberMutation(
  baseOptions?: Apollo.MutationHookOptions<SetInsuranceNumberMutation, SetInsuranceNumberMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetInsuranceNumberMutation, SetInsuranceNumberMutationVariables>(
    SetInsuranceNumberDocument,
    options
  );
}
export type SetInsuranceNumberMutationHookResult = ReturnType<typeof useSetInsuranceNumberMutation>;
export type SetInsuranceNumberMutationResult = Apollo.MutationResult<SetInsuranceNumberMutation>;
export type SetInsuranceNumberMutationOptions = Apollo.BaseMutationOptions<
  SetInsuranceNumberMutation,
  SetInsuranceNumberMutationVariables
>;
export const SetCheckoutPaymentAttemptDocument = gql`
  mutation setCheckoutPaymentAttempt($offerId: String!) {
    setCheckoutPaymentAttempt(offerId: $offerId)
  }
`;
export type SetCheckoutPaymentAttemptMutationFn = Apollo.MutationFunction<
  SetCheckoutPaymentAttemptMutation,
  SetCheckoutPaymentAttemptMutationVariables
>;

/**
 * __useSetCheckoutPaymentAttemptMutation__
 *
 * To run a mutation, you first call `useSetCheckoutPaymentAttemptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCheckoutPaymentAttemptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCheckoutPaymentAttemptMutation, { data, loading, error }] = useSetCheckoutPaymentAttemptMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useSetCheckoutPaymentAttemptMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCheckoutPaymentAttemptMutation,
    SetCheckoutPaymentAttemptMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetCheckoutPaymentAttemptMutation, SetCheckoutPaymentAttemptMutationVariables>(
    SetCheckoutPaymentAttemptDocument,
    options
  );
}
export type SetCheckoutPaymentAttemptMutationHookResult = ReturnType<typeof useSetCheckoutPaymentAttemptMutation>;
export type SetCheckoutPaymentAttemptMutationResult = Apollo.MutationResult<SetCheckoutPaymentAttemptMutation>;
export type SetCheckoutPaymentAttemptMutationOptions = Apollo.BaseMutationOptions<
  SetCheckoutPaymentAttemptMutation,
  SetCheckoutPaymentAttemptMutationVariables
>;
export const SetCheckoutPaymentErrorsDocument = gql`
  mutation setCheckoutPaymentErrors($offerId: String!, $errors: [String]!) {
    setCheckoutPaymentErrors(offerId: $offerId, errors: $errors)
  }
`;
export type SetCheckoutPaymentErrorsMutationFn = Apollo.MutationFunction<
  SetCheckoutPaymentErrorsMutation,
  SetCheckoutPaymentErrorsMutationVariables
>;

/**
 * __useSetCheckoutPaymentErrorsMutation__
 *
 * To run a mutation, you first call `useSetCheckoutPaymentErrorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCheckoutPaymentErrorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCheckoutPaymentErrorsMutation, { data, loading, error }] = useSetCheckoutPaymentErrorsMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *      errors: // value for 'errors'
 *   },
 * });
 */
export function useSetCheckoutPaymentErrorsMutation(
  baseOptions?: Apollo.MutationHookOptions<SetCheckoutPaymentErrorsMutation, SetCheckoutPaymentErrorsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetCheckoutPaymentErrorsMutation, SetCheckoutPaymentErrorsMutationVariables>(
    SetCheckoutPaymentErrorsDocument,
    options
  );
}
export type SetCheckoutPaymentErrorsMutationHookResult = ReturnType<typeof useSetCheckoutPaymentErrorsMutation>;
export type SetCheckoutPaymentErrorsMutationResult = Apollo.MutationResult<SetCheckoutPaymentErrorsMutation>;
export type SetCheckoutPaymentErrorsMutationOptions = Apollo.BaseMutationOptions<
  SetCheckoutPaymentErrorsMutation,
  SetCheckoutPaymentErrorsMutationVariables
>;
export const UpdateCheckoutHealthOfferDataDocument = gql`
  mutation updateCheckoutHealthOfferData($params: CheckoutHealthOfferDataInput!) {
    updateCheckoutHealthOfferData(params: $params)
  }
`;
export type UpdateCheckoutHealthOfferDataMutationFn = Apollo.MutationFunction<
  UpdateCheckoutHealthOfferDataMutation,
  UpdateCheckoutHealthOfferDataMutationVariables
>;

/**
 * __useUpdateCheckoutHealthOfferDataMutation__
 *
 * To run a mutation, you first call `useUpdateCheckoutHealthOfferDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckoutHealthOfferDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckoutHealthOfferDataMutation, { data, loading, error }] = useUpdateCheckoutHealthOfferDataMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateCheckoutHealthOfferDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCheckoutHealthOfferDataMutation,
    UpdateCheckoutHealthOfferDataMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCheckoutHealthOfferDataMutation, UpdateCheckoutHealthOfferDataMutationVariables>(
    UpdateCheckoutHealthOfferDataDocument,
    options
  );
}
export type UpdateCheckoutHealthOfferDataMutationHookResult = ReturnType<
  typeof useUpdateCheckoutHealthOfferDataMutation
>;
export type UpdateCheckoutHealthOfferDataMutationResult = Apollo.MutationResult<UpdateCheckoutHealthOfferDataMutation>;
export type UpdateCheckoutHealthOfferDataMutationOptions = Apollo.BaseMutationOptions<
  UpdateCheckoutHealthOfferDataMutation,
  UpdateCheckoutHealthOfferDataMutationVariables
>;
export const GetAdminDocument = gql`
  query getAdmin($referenceId: String!, $referenceType: String!, $isEncrypted: Boolean!) {
    admin {
      assignedAdminByReference(referenceId: $referenceId, referenceType: $referenceType, isEncrypted: $isEncrypted) {
        id
        avatar
        name
        email
        phone
        phoneExt
        signature
        emailName
      }
    }
  }
`;

/**
 * __useGetAdminQuery__
 *
 * To run a query within a React component, call `useGetAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminQuery({
 *   variables: {
 *      referenceId: // value for 'referenceId'
 *      referenceType: // value for 'referenceType'
 *      isEncrypted: // value for 'isEncrypted'
 *   },
 * });
 */
export function useGetAdminQuery(
  baseOptions: Apollo.QueryHookOptions<GetAdminQuery, GetAdminQueryVariables> &
    ({ variables: GetAdminQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAdminQuery, GetAdminQueryVariables>(GetAdminDocument, options);
}
export function useGetAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminQuery, GetAdminQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAdminQuery, GetAdminQueryVariables>(GetAdminDocument, options);
}
export function useGetAdminSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminQuery, GetAdminQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAdminQuery, GetAdminQueryVariables>(GetAdminDocument, options);
}
export type GetAdminQueryHookResult = ReturnType<typeof useGetAdminQuery>;
export type GetAdminLazyQueryHookResult = ReturnType<typeof useGetAdminLazyQuery>;
export type GetAdminSuspenseQueryHookResult = ReturnType<typeof useGetAdminSuspenseQuery>;
export type GetAdminQueryResult = Apollo.QueryResult<GetAdminQuery, GetAdminQueryVariables>;
export const CheckoutHealthOfferDocument = gql`
  query checkoutHealthOffer($offerId: String!) {
    health {
      checkoutHealthOffer(offerId: $offerId) {
        _id
        publicSoId
        status
        brandId
        publicOfferId
        supplementary {
          label
          actionLabel
          brandName
          brandCode
          priceChangeModifier {
            amount
            type
            description
          }
          voucherPriceModifier {
            amount
          }
          voucherPriceChangeModifier {
            amount
            type
            description
            code
          }
          numberOfInstallments
          code
          visual {
            highlight
            tooltip
            description
          }
          logoUrl
          fixedCoverages {
            label
            tooltip
            value
            price
            gratis {
              value
              type
            }
            options {
              key
              value
            }
          }
          coverages {
            label
            tooltip
            value
            price
            gratis {
              value
              type
            }
            options {
              key
              value
            }
          }
          discounts {
            value
            tooltip
          }
          paymentSlipInfo {
            amount
            numOfInstallments
          }
          total {
            generalTransfer
            generalTransferWithInstallments
            creditCard
            creditCardWithInstallments
          }
          includedInPrice {
            label
            description
          }
          additionalCoverages {
            label
            description
          }
        }
        additional {
          label
          brandName
          brandCode
          priceChangeModifier {
            amount
            type
            description
          }
          voucherPriceModifier {
            amount
          }
          numberOfInstallments
          code
          visual {
            highlight
            tooltip
            description
          }
          logoUrl
          coverages {
            label
            tooltip
            value
            price
            gratis {
              value
              type
            }
            options {
              key
              value
            }
          }
          fixedCoverages {
            label
            tooltip
            value
            price
            gratis {
              value
              type
            }
            options {
              key
              value
            }
          }
          discounts {
            value
            tooltip
          }
          total {
            generalTransfer
            generalTransferWithInstallments
            creditCard
            creditCardWithInstallments
          }
          includedInPrice {
            label
            description
          }
          additionalCoverages {
            label
            description
          }
        }
        total {
          generalTransfer
          generalTransferWithInstallments
          creditCard
          creditCardWithInstallments
        }
        annotations
      }
      checkoutHealthOfferData(offerId: $offerId) {
        karenca
        newPolicyStartDate
        newPolicyStartDateNote
        productCode
        insuredPerson {
          firstName {
            value
            isEditable
          }
          lastName {
            value
            isEditable
          }
          birthDate {
            value
            isEditable
          }
          gender {
            value
            isEditable
          }
          streetAndHouseNumber {
            value
            isEditable
          }
          street {
            value
            isEditable
          }
          streetKompareId {
            value
            isEditable
          }
          houseNumber {
            value
            isEditable
          }
          city {
            value
            isEditable
          }
          cityKompareId {
            value
            isEditable
          }
          zipCode {
            value
            isEditable
          }
          oib {
            value
            isEditable
          }
          insuranceNumber {
            value
            isEditable
          }
          personalIdNumber {
            value
            isEditable
          }
          personalIdIssuer {
            value
            isEditable
          }
          partnerContactEmail {
            value
            isEditable
          }
        }
        contractor {
          personType
          isSamePerson
          person {
            firstName {
              value
              isEditable
            }
            lastName {
              value
              isEditable
            }
            birthDate {
              value
              isEditable
            }
            gender {
              value
              isEditable
            }
            streetAndHouseNumber {
              value
              isEditable
            }
            street {
              value
              isEditable
            }
            houseNumber {
              value
              isEditable
            }
            streetKompareId {
              value
              isEditable
            }
            city {
              value
              isEditable
            }
            cityKompareId {
              value
              isEditable
            }
            zipCode {
              value
              isEditable
            }
            oib {
              value
              isEditable
            }
            partnerContactEmail {
              value
              isEditable
            }
          }
          company {
            streetAndHouseNumber {
              value
              isEditable
            }
            street {
              value
              isEditable
            }
            houseNumber {
              value
              isEditable
            }
            streetKompareId {
              value
              isEditable
            }
            oib {
              value
              isEditable
            }
            city {
              value
              isEditable
            }
            cityKompareId {
              value
              isEditable
            }
            companyName {
              value
              isEditable
            }
            zipCode {
              value
              isEditable
            }
            partnerContactEmail {
              value
              isEditable
            }
          }
        }
        delivery {
          asEntity {
            value
            isEditable
          }
          name {
            value
            isEditable
          }
          streetAndHouseNumber {
            value
            isEditable
          }
          street {
            value
            isEditable
          }
          streetKompareId {
            value
            isEditable
          }
          houseNumber {
            value
            isEditable
          }
          city {
            value
            isEditable
          }
          cityKompareId {
            value
            isEditable
          }
          zipCode {
            value
            isEditable
          }
        }
      }
      checkoutHealthOfferDocuments(offerId: $offerId) {
        src
        title
      }
    }
  }
`;

/**
 * __useCheckoutHealthOfferQuery__
 *
 * To run a query within a React component, call `useCheckoutHealthOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutHealthOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutHealthOfferQuery({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useCheckoutHealthOfferQuery(
  baseOptions: Apollo.QueryHookOptions<CheckoutHealthOfferQuery, CheckoutHealthOfferQueryVariables> &
    ({ variables: CheckoutHealthOfferQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckoutHealthOfferQuery, CheckoutHealthOfferQueryVariables>(
    CheckoutHealthOfferDocument,
    options
  );
}
export function useCheckoutHealthOfferLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CheckoutHealthOfferQuery, CheckoutHealthOfferQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CheckoutHealthOfferQuery, CheckoutHealthOfferQueryVariables>(
    CheckoutHealthOfferDocument,
    options
  );
}
export function useCheckoutHealthOfferSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CheckoutHealthOfferQuery, CheckoutHealthOfferQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CheckoutHealthOfferQuery, CheckoutHealthOfferQueryVariables>(
    CheckoutHealthOfferDocument,
    options
  );
}
export type CheckoutHealthOfferQueryHookResult = ReturnType<typeof useCheckoutHealthOfferQuery>;
export type CheckoutHealthOfferLazyQueryHookResult = ReturnType<typeof useCheckoutHealthOfferLazyQuery>;
export type CheckoutHealthOfferSuspenseQueryHookResult = ReturnType<typeof useCheckoutHealthOfferSuspenseQuery>;
export type CheckoutHealthOfferQueryResult = Apollo.QueryResult<
  CheckoutHealthOfferQuery,
  CheckoutHealthOfferQueryVariables
>;
export const CheckoutHealthOfferDataDocument = gql`
  query checkoutHealthOfferData($offerId: String!) {
    health {
      checkoutHealthOfferData(offerId: $offerId) {
        karenca
        newPolicyStartDate
        newPolicyStartDateNote
        productCode
        insuredPerson {
          firstName {
            value
            isEditable
          }
          lastName {
            value
            isEditable
          }
          birthDate {
            value
            isEditable
          }
          gender {
            value
            isEditable
          }
          streetAndHouseNumber {
            value
            isEditable
          }
          street {
            value
            isEditable
          }
          streetKompareId {
            value
            isEditable
          }
          houseNumber {
            value
            isEditable
          }
          city {
            value
            isEditable
          }
          cityKompareId {
            value
            isEditable
          }
          zipCode {
            value
            isEditable
          }
          oib {
            value
            isEditable
          }
          personalIdNumber {
            value
            isEditable
          }
          personalIdIssuer {
            value
            isEditable
          }
          partnerContactEmail {
            value
            isEditable
          }
        }
        contractor {
          personType
          isSamePerson
          person {
            firstName {
              value
              isEditable
            }
            lastName {
              value
              isEditable
            }
            birthDate {
              value
              isEditable
            }
            gender {
              value
              isEditable
            }
            streetAndHouseNumber {
              value
              isEditable
            }
            street {
              value
              isEditable
            }
            houseNumber {
              value
              isEditable
            }
            streetKompareId {
              value
              isEditable
            }
            city {
              value
              isEditable
            }
            cityKompareId {
              value
              isEditable
            }
            zipCode {
              value
              isEditable
            }
            oib {
              value
              isEditable
            }
            partnerContactEmail {
              value
              isEditable
            }
          }
          company {
            streetAndHouseNumber {
              value
              isEditable
            }
            street {
              value
              isEditable
            }
            houseNumber {
              value
              isEditable
            }
            streetKompareId {
              value
              isEditable
            }
            oib {
              value
              isEditable
            }
            city {
              value
              isEditable
            }
            cityKompareId {
              value
              isEditable
            }
            companyName {
              value
              isEditable
            }
            zipCode {
              value
              isEditable
            }
            partnerContactEmail {
              value
              isEditable
            }
          }
        }
        delivery {
          asEntity {
            value
            isEditable
          }
          name {
            value
            isEditable
          }
          streetAndHouseNumber {
            value
            isEditable
          }
          street {
            value
            isEditable
          }
          streetKompareId {
            value
            isEditable
          }
          houseNumber {
            value
            isEditable
          }
          city {
            value
            isEditable
          }
          cityKompareId {
            value
            isEditable
          }
          zipCode {
            value
            isEditable
          }
        }
      }
    }
  }
`;

/**
 * __useCheckoutHealthOfferDataQuery__
 *
 * To run a query within a React component, call `useCheckoutHealthOfferDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutHealthOfferDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutHealthOfferDataQuery({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useCheckoutHealthOfferDataQuery(
  baseOptions: Apollo.QueryHookOptions<CheckoutHealthOfferDataQuery, CheckoutHealthOfferDataQueryVariables> &
    ({ variables: CheckoutHealthOfferDataQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckoutHealthOfferDataQuery, CheckoutHealthOfferDataQueryVariables>(
    CheckoutHealthOfferDataDocument,
    options
  );
}
export function useCheckoutHealthOfferDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CheckoutHealthOfferDataQuery, CheckoutHealthOfferDataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CheckoutHealthOfferDataQuery, CheckoutHealthOfferDataQueryVariables>(
    CheckoutHealthOfferDataDocument,
    options
  );
}
export function useCheckoutHealthOfferDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CheckoutHealthOfferDataQuery, CheckoutHealthOfferDataQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CheckoutHealthOfferDataQuery, CheckoutHealthOfferDataQueryVariables>(
    CheckoutHealthOfferDataDocument,
    options
  );
}
export type CheckoutHealthOfferDataQueryHookResult = ReturnType<typeof useCheckoutHealthOfferDataQuery>;
export type CheckoutHealthOfferDataLazyQueryHookResult = ReturnType<typeof useCheckoutHealthOfferDataLazyQuery>;
export type CheckoutHealthOfferDataSuspenseQueryHookResult = ReturnType<typeof useCheckoutHealthOfferDataSuspenseQuery>;
export type CheckoutHealthOfferDataQueryResult = Apollo.QueryResult<
  CheckoutHealthOfferDataQuery,
  CheckoutHealthOfferDataQueryVariables
>;
export const CheckoutHealthOfferGeneralTransferDetailsDocument = gql`
  query checkoutHealthOfferGeneralTransferDetails($offerId: String!, $installments: Int!) {
    health {
      checkoutHealthOfferGeneralTransferDetails(offerId: $offerId, installments: $installments) {
        price
        customerFirstName
        customerLastName
        customerAddress
        customerCity
        customerZipCode
        customerCountry
        customerPhone
        customerEmail
        customerOib
        recipientAccountNumber
        recipientAddress
        recipientCity
        recipientZipCode
        recipientName
        referenceNumberType
        referenceNumber
        referencePrefix
        referenceSuffix
        model
        description
        numberOfInstallments
      }
    }
  }
`;

/**
 * __useCheckoutHealthOfferGeneralTransferDetailsQuery__
 *
 * To run a query within a React component, call `useCheckoutHealthOfferGeneralTransferDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutHealthOfferGeneralTransferDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutHealthOfferGeneralTransferDetailsQuery({
 *   variables: {
 *      offerId: // value for 'offerId'
 *      installments: // value for 'installments'
 *   },
 * });
 */
export function useCheckoutHealthOfferGeneralTransferDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckoutHealthOfferGeneralTransferDetailsQuery,
    CheckoutHealthOfferGeneralTransferDetailsQueryVariables
  > &
    ({ variables: CheckoutHealthOfferGeneralTransferDetailsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckoutHealthOfferGeneralTransferDetailsQuery,
    CheckoutHealthOfferGeneralTransferDetailsQueryVariables
  >(CheckoutHealthOfferGeneralTransferDetailsDocument, options);
}
export function useCheckoutHealthOfferGeneralTransferDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckoutHealthOfferGeneralTransferDetailsQuery,
    CheckoutHealthOfferGeneralTransferDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckoutHealthOfferGeneralTransferDetailsQuery,
    CheckoutHealthOfferGeneralTransferDetailsQueryVariables
  >(CheckoutHealthOfferGeneralTransferDetailsDocument, options);
}
export function useCheckoutHealthOfferGeneralTransferDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckoutHealthOfferGeneralTransferDetailsQuery,
        CheckoutHealthOfferGeneralTransferDetailsQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CheckoutHealthOfferGeneralTransferDetailsQuery,
    CheckoutHealthOfferGeneralTransferDetailsQueryVariables
  >(CheckoutHealthOfferGeneralTransferDetailsDocument, options);
}
export type CheckoutHealthOfferGeneralTransferDetailsQueryHookResult = ReturnType<
  typeof useCheckoutHealthOfferGeneralTransferDetailsQuery
>;
export type CheckoutHealthOfferGeneralTransferDetailsLazyQueryHookResult = ReturnType<
  typeof useCheckoutHealthOfferGeneralTransferDetailsLazyQuery
>;
export type CheckoutHealthOfferGeneralTransferDetailsSuspenseQueryHookResult = ReturnType<
  typeof useCheckoutHealthOfferGeneralTransferDetailsSuspenseQuery
>;
export type CheckoutHealthOfferGeneralTransferDetailsQueryResult = Apollo.QueryResult<
  CheckoutHealthOfferGeneralTransferDetailsQuery,
  CheckoutHealthOfferGeneralTransferDetailsQueryVariables
>;
export const CheckoutHealthOfferPaymentOptionsDocument = gql`
  query checkoutHealthOfferPaymentOptions($offerId: String!) {
    health {
      checkoutHealthOfferPaymentOptions(offerId: $offerId) {
        offer {
          status
          brandId
          supplementary {
            label
            brandName
            brandCode
            code
            total {
              generalTransfer
              generalTransferWithInstallments
              creditCard
              creditCardWithInstallments
            }
            actionLabel
          }
          additional {
            label
            brandName
            brandCode
            code
            total {
              generalTransfer
              generalTransferWithInstallments
              creditCard
              creditCardWithInstallments
            }
          }
        }
        paymentOptions {
          paymentOption
          paymentTypes {
            paymentType
            paymentTypeLabel
            installments {
              installment
              amount
              paymentTypeDiscount
            }
          }
          paymentSlipInfo {
            amount
            numOfInstallments
          }
        }
      }
      checkoutHealthOfferGeneralTransferDetailsOneTime: checkoutHealthOfferGeneralTransferDetails(
        offerId: $offerId
        installments: 1
      ) {
        price
        customerFirstName
        customerLastName
        customerAddress
        customerCity
        customerZipCode
        customerCountry
        customerPhone
        customerEmail
        customerOib
        recipientAccountNumber
        recipientAddress
        recipientCity
        recipientZipCode
        recipientName
        referenceNumber
        referenceNumberType
        referencePrefix
        referenceSuffix
        model
        description
        numberOfInstallments
      }
      checkoutHealthOfferGeneralTransferDetailsInstallments: checkoutHealthOfferGeneralTransferDetails(
        offerId: $offerId
        installments: 12
      ) {
        price
        customerFirstName
        customerLastName
        customerAddress
        customerCity
        customerZipCode
        customerCountry
        customerPhone
        customerEmail
        customerOib
        recipientAccountNumber
        recipientAddress
        recipientCity
        recipientZipCode
        recipientName
        referenceNumber
        referenceNumberType
        referencePrefix
        referenceSuffix
        model
        description
        numberOfInstallments
      }
      checkoutHealthOffer(offerId: $offerId) {
        _id
        publicSoId
        status
        brandId
        publicOfferId
        supplementary {
          label
          actionLabel
          brandName
          brandCode
          priceChangeModifier {
            amount
            type
            description
          }
          voucherPriceModifier {
            amount
          }
          voucherPriceChangeModifier {
            amount
            type
            description
            code
          }
          numberOfInstallments
          code
          visual {
            highlight
            tooltip
            description
          }
          logoUrl
          fixedCoverages {
            label
            tooltip
            value
            price
            gratis {
              value
              type
            }
            options {
              key
              value
            }
          }
          coverages {
            label
            tooltip
            value
            price
            gratis {
              value
              type
            }
            options {
              key
              value
            }
          }
          discounts {
            value
            tooltip
          }
          paymentSlipInfo {
            amount
            numOfInstallments
          }
          total {
            generalTransfer
            generalTransferWithInstallments
            creditCard
            creditCardWithInstallments
          }
        }
        additional {
          label
          brandName
          brandCode
          priceChangeModifier {
            amount
            type
            description
          }
          voucherPriceModifier {
            amount
          }
          numberOfInstallments
          code
          visual {
            highlight
            tooltip
            description
          }
          logoUrl
          coverages {
            label
            tooltip
            value
            price
            gratis {
              value
              type
            }
            options {
              key
              value
            }
          }
          fixedCoverages {
            label
            tooltip
            value
            price
            gratis {
              value
              type
            }
            options {
              key
              value
            }
          }
          discounts {
            value
            tooltip
          }
          total {
            generalTransfer
            generalTransferWithInstallments
            creditCard
            creditCardWithInstallments
          }
        }
        total {
          generalTransfer
          generalTransferWithInstallments
          creditCard
          creditCardWithInstallments
        }
        annotations
      }
    }
  }
`;

/**
 * __useCheckoutHealthOfferPaymentOptionsQuery__
 *
 * To run a query within a React component, call `useCheckoutHealthOfferPaymentOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutHealthOfferPaymentOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutHealthOfferPaymentOptionsQuery({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useCheckoutHealthOfferPaymentOptionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckoutHealthOfferPaymentOptionsQuery,
    CheckoutHealthOfferPaymentOptionsQueryVariables
  > &
    ({ variables: CheckoutHealthOfferPaymentOptionsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckoutHealthOfferPaymentOptionsQuery, CheckoutHealthOfferPaymentOptionsQueryVariables>(
    CheckoutHealthOfferPaymentOptionsDocument,
    options
  );
}
export function useCheckoutHealthOfferPaymentOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckoutHealthOfferPaymentOptionsQuery,
    CheckoutHealthOfferPaymentOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CheckoutHealthOfferPaymentOptionsQuery, CheckoutHealthOfferPaymentOptionsQueryVariables>(
    CheckoutHealthOfferPaymentOptionsDocument,
    options
  );
}
export function useCheckoutHealthOfferPaymentOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckoutHealthOfferPaymentOptionsQuery,
        CheckoutHealthOfferPaymentOptionsQueryVariables
      >
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CheckoutHealthOfferPaymentOptionsQuery,
    CheckoutHealthOfferPaymentOptionsQueryVariables
  >(CheckoutHealthOfferPaymentOptionsDocument, options);
}
export type CheckoutHealthOfferPaymentOptionsQueryHookResult = ReturnType<
  typeof useCheckoutHealthOfferPaymentOptionsQuery
>;
export type CheckoutHealthOfferPaymentOptionsLazyQueryHookResult = ReturnType<
  typeof useCheckoutHealthOfferPaymentOptionsLazyQuery
>;
export type CheckoutHealthOfferPaymentOptionsSuspenseQueryHookResult = ReturnType<
  typeof useCheckoutHealthOfferPaymentOptionsSuspenseQuery
>;
export type CheckoutHealthOfferPaymentOptionsQueryResult = Apollo.QueryResult<
  CheckoutHealthOfferPaymentOptionsQuery,
  CheckoutHealthOfferPaymentOptionsQueryVariables
>;
export const WsPayPaymentDetailsDocument = gql`
  query wsPayPaymentDetails(
    $offerId: String!
    $paymentOption: HealthOfferPaymentOptionEnum!
    $paymentType: String!
    $installments: Int!
  ) {
    health {
      checkoutHealthOfferWSPayPaymentDetails(
        offerId: $offerId
        paymentType: $paymentType
        paymentOption: $paymentOption
        installments: $installments
      ) {
        ShopID
        ShoppingCartID
        TotalAmount
        Signature
        ReturnURL
        CancelURL
        ReturnErrorURL
        PaymentPlan
        CustomerFirstName
        CustomerLastName
        CustomerAddress
        CustomerAddress
        CustomerCity
        CustomerZIP
        CustomerCountry
        CustomerPhone
        CustomerEmail
        PaymentMethod
        Iframe
        IframeResponseTarget
      }
    }
  }
`;

/**
 * __useWsPayPaymentDetailsQuery__
 *
 * To run a query within a React component, call `useWsPayPaymentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWsPayPaymentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWsPayPaymentDetailsQuery({
 *   variables: {
 *      offerId: // value for 'offerId'
 *      paymentOption: // value for 'paymentOption'
 *      paymentType: // value for 'paymentType'
 *      installments: // value for 'installments'
 *   },
 * });
 */
export function useWsPayPaymentDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<WsPayPaymentDetailsQuery, WsPayPaymentDetailsQueryVariables> &
    ({ variables: WsPayPaymentDetailsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WsPayPaymentDetailsQuery, WsPayPaymentDetailsQueryVariables>(
    WsPayPaymentDetailsDocument,
    options
  );
}
export function useWsPayPaymentDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<WsPayPaymentDetailsQuery, WsPayPaymentDetailsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WsPayPaymentDetailsQuery, WsPayPaymentDetailsQueryVariables>(
    WsPayPaymentDetailsDocument,
    options
  );
}
export function useWsPayPaymentDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<WsPayPaymentDetailsQuery, WsPayPaymentDetailsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<WsPayPaymentDetailsQuery, WsPayPaymentDetailsQueryVariables>(
    WsPayPaymentDetailsDocument,
    options
  );
}
export type WsPayPaymentDetailsQueryHookResult = ReturnType<typeof useWsPayPaymentDetailsQuery>;
export type WsPayPaymentDetailsLazyQueryHookResult = ReturnType<typeof useWsPayPaymentDetailsLazyQuery>;
export type WsPayPaymentDetailsSuspenseQueryHookResult = ReturnType<typeof useWsPayPaymentDetailsSuspenseQuery>;
export type WsPayPaymentDetailsQueryResult = Apollo.QueryResult<
  WsPayPaymentDetailsQuery,
  WsPayPaymentDetailsQueryVariables
>;
export const CheckoutHealthOffersDocument = gql`
  query checkoutHealthOffers($soId: String!) {
    health {
      checkoutHealthOffers(soId: $soId) {
        _id
        publicSoId
        publicOfferId
        brandId
        status
        paidAt
        isPublished
        annotations
        termsAcceptedAt
        iddTermsAcceptedAt
        allianzGDPRAcceptedAt
        acceptedEmailDocumentationDeliveryAt
        supplementary {
          label
          code
          brandName
          brandCode
          logoUrl
          numberOfInstallments
          baseProductPrice
          actionLabel
          includedInPrice {
            label
            description
          }
          additionalCoverages {
            label
            description
          }
        }
        additional {
          label
          code
          brandName
          brandCode
          logoUrl
          numberOfInstallments
          baseProductPrice
        }
        total {
          generalTransfer
          generalTransferWithInstallments
          creditCard
          creditCardWithInstallments
        }
      }
    }
  }
`;

/**
 * __useCheckoutHealthOffersQuery__
 *
 * To run a query within a React component, call `useCheckoutHealthOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutHealthOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutHealthOffersQuery({
 *   variables: {
 *      soId: // value for 'soId'
 *   },
 * });
 */
export function useCheckoutHealthOffersQuery(
  baseOptions: Apollo.QueryHookOptions<CheckoutHealthOffersQuery, CheckoutHealthOffersQueryVariables> &
    ({ variables: CheckoutHealthOffersQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckoutHealthOffersQuery, CheckoutHealthOffersQueryVariables>(
    CheckoutHealthOffersDocument,
    options
  );
}
export function useCheckoutHealthOffersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CheckoutHealthOffersQuery, CheckoutHealthOffersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CheckoutHealthOffersQuery, CheckoutHealthOffersQueryVariables>(
    CheckoutHealthOffersDocument,
    options
  );
}
export function useCheckoutHealthOffersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CheckoutHealthOffersQuery, CheckoutHealthOffersQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CheckoutHealthOffersQuery, CheckoutHealthOffersQueryVariables>(
    CheckoutHealthOffersDocument,
    options
  );
}
export type CheckoutHealthOffersQueryHookResult = ReturnType<typeof useCheckoutHealthOffersQuery>;
export type CheckoutHealthOffersLazyQueryHookResult = ReturnType<typeof useCheckoutHealthOffersLazyQuery>;
export type CheckoutHealthOffersSuspenseQueryHookResult = ReturnType<typeof useCheckoutHealthOffersSuspenseQuery>;
export type CheckoutHealthOffersQueryResult = Apollo.QueryResult<
  CheckoutHealthOffersQuery,
  CheckoutHealthOffersQueryVariables
>;
export const HealthDocument = gql`
  query Health($birthDate: String!) {
    health {
      webCalculationsSupplementary(birthDate: $birthDate) {
        productCode
        productLabel
        brandName
        actionLabel
        price {
          totalOneTimePayment
          totalWithInstallments
        }
        includedInPrice {
          label
          description
        }
        additionalCoverages {
          label
          description
        }
        logo
      }
    }
  }
`;

/**
 * __useHealthQuery__
 *
 * To run a query within a React component, call `useHealthQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHealthQuery({
 *   variables: {
 *      birthDate: // value for 'birthDate'
 *   },
 * });
 */
export function useHealthQuery(
  baseOptions: Apollo.QueryHookOptions<HealthQuery, HealthQueryVariables> &
    ({ variables: HealthQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HealthQuery, HealthQueryVariables>(HealthDocument, options);
}
export function useHealthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HealthQuery, HealthQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<HealthQuery, HealthQueryVariables>(HealthDocument, options);
}
export function useHealthSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HealthQuery, HealthQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<HealthQuery, HealthQueryVariables>(HealthDocument, options);
}
export type HealthQueryHookResult = ReturnType<typeof useHealthQuery>;
export type HealthLazyQueryHookResult = ReturnType<typeof useHealthLazyQuery>;
export type HealthSuspenseQueryHookResult = ReturnType<typeof useHealthSuspenseQuery>;
export type HealthQueryResult = Apollo.QueryResult<HealthQuery, HealthQueryVariables>;
